import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SuperMarket.css';

function BeautyCare() {
  const [categories] = useState({
    
      "Skin Care": [

  { "name": "Cetaphil Moisturizing Lotion 100ml", "price": 210 },
  { "name": "Neutrogena Hydro Boost Water Gel 50g", "price": 675 },
  { "name": "Plum Green Tea Oil-Free Moisturizer 50ml", "price": 399 },
  { "name": "Minimalist 10% Vitamin B5 Moisturizer 50ml", "price": 349 },
  { "name": "Lakmé Peach Milk Moisturizer SPF 24 200ml", "price": 325 },
  { "name": "Dot & Key Vitamin C + E Sorbet Moisturizer 60ml", "price": 495 },
  { "name": "Re’equil Oil-Free Moisturizer 100g", "price": 450 },
  { "name": "St. Botanica Bulgarian Rose Otto Glow Moisturizer 50ml", "price": 699 },
  { "name": "Mamaearth Rice Water Moisturizer 80ml", "price": 349 },
  { "name": "Foxtale Ceramide Supercream Moisturizer 50ml", "price": 495 },

  { "name": "Cetaphil Gentle Skin Cleanser 125ml", "price": 399 },
  { "name": "Neutrogena Deep Clean Facial Cleanser 200ml", "price": 525 },
  { "name": "L'Oréal Revitalift Vitamin C + Salicylic Acid Cleanser 150ml", "price": 958 },
  { "name": "Mamaearth Tea Tree Face Wash 100ml", "price": 259 },
  { "name": "Plum Green Tea Pore Cleansing Face Wash 120ml", "price": 345 },
  { "name": "Clean & Clear Foaming Face Wash 150ml", "price": 185 },
  { "name": "Himalaya Neem Face Wash 150ml", "price": 213 },
  { "name": "St. Botanica Vitamin C Face Wash 100ml", "price": 279 },
  { "name": "WOW Apple Cider Vinegar Foaming Face Wash 100ml", "price": 295 },
  { "name": "Astaberry Acai Berry Foaming Face Wash 100ml", "price": 256 },

  { "name": "Lotus Herbals WhiteGlow Pink Glow Exfoliator 100g", "price": 275 },
  { "name": "Clarins One-Step Gentle Exfoliating Cleanser 200ml", "price": 2300 },
  { "name": "Hyphen 10% AHA BHA PHA Exfoliator 50ml", "price": 549 },
  { "name": "Just Herbs Apricot Sparkle Scrub 100g", "price": 445 },
  { "name": "Nivea Gentle Exfoliating Scrub 150ml", "price": 299 },
  { "name": "Clean & Clear Deep Action Exfoliating Scrub 100g", "price": 275 },
  { "name": "Biotique Papaya Tan Removal Scrub 100g", "price": 199 },
  { "name": "Mamaearth Ubtan Face Scrub 100g", "price": 349 },
  { "name": "mCaffeine Coffee Face Scrub 100g", "price": 399 },
  { "name": "Plum Chamomile & White Tea Face Scrub 75g", "price": 325 },

  { "name": "Minimalist 10% Vitamin C Serum 30ml", "price": 569 },
  { "name": "The Derma Co 10% Niacinamide Serum 30ml", "price": 551 },
  { "name": "Pilgrim 10% Vitamin C Serum 30ml", "price": 447 },
  { "name": "Foxtale 15% Vitamin C Serum 30ml", "price": 425 },
  { "name": "Plum 15% Vitamin C Serum 20ml", "price": 467 },
  { "name": "Mamaearth Vitamin C Daily Glow Serum 30ml", "price": 342 },
  { "name": "Dot & Key 10% Vitamin C + E Serum 20ml", "price": 429 },
  { "name": "Deconstruct 10% Vitamin C Serum 30ml", "price": 615 },
  { "name": "WishCare Super Bright C16 Vitamin C Serum 30ml", "price": 570 },
  { "name": "L'Oreal Paris Glycolic Bright Serum 30ml", "price": 434 },

  { "name": "Mamaearth Ultra Light Indian Sunscreen SPF 50 80g", "price": 499 },
  { "name": "Novology SPF 50 PA++++ Hydrating Sunscreen 50ml", "price": 600 },
  { "name": "Uniqaya Tinted Sunscreen SPF 50 PA+++ 50ml", "price": 899 },
  { "name": "Meglow Pro-Care SPF 50 PA+++ Sunscreen Lotion 50ml", "price": 350 },
  { "name": "Mamaearth Vitamin C Daily Glow Sunscreen SPF 50 80g", "price": 499 },
  { "name": "Foxtale Mattifying Sunscreen SPF 50 50ml", "price": 495 },
  { "name": "Dot & Key Watermelon Cooling Sunscreen SPF 50 50ml", "price": 445 },
  { "name": "Re’equil Ultra Matte Dry Touch Sunscreen Gel SPF 50 50g", "price": 550 },
  { "name": "Plum Green Tea Daylight Sunscreen SPF 35 50ml", "price": 399 },
  { "name": "Dr. Sheth’s Ceramide & Vitamin C Sunscreen SPF 50 50ml", "price": 499 },

  { "name": "Mamaearth Ubtan Face Mask 100ml", "price": 499 },
  { "name": "Plum Green Tea Clear Face Mask 60g", "price": 490 },
  { "name": "Dot & Key Pink Clay Face Mask 85g", "price": 595 },
  { "name": "Pilgrim Volcanic Lava Ash Face Mask 100g", "price": 450 },
  { "name": "The Derma Co 2% Salicylic Acid Clay Mask 50g", "price": 499 },
  { "name": "Foxtale Deep Hydration Face Mask 50ml", "price": 495 },
  { "name": "St. Botanica Vitamin C Brightening Face Mask 100g", "price": 599 },
  { "name": "WOW Skin Science Activated Charcoal Face Mask 100ml", "price": 399 },
  { "name": "Biotique Bio Milk Protein Whitening Face Pack 100g", "price": 199 },
  { "name": "Khadi Natural Herbal Face Mask with Neem & Tulsi 100g", "price": 250 },



  { "name": "Cetaphil DAM Ultra Hydrating Lotion", "price": 486 },
  { "name": "Neutrogena Hydro Boost Water Gel", "price": 849 },
  { "name": "Minimalist 10% Vitamin B5 Moisturizer", "price": 349 },
  { "name": "Dot & Key Vitamin C + E Sorbet Moisturizer", "price": 445 },
  { "name": "Plum Green Tea Oil-Free Moisturizer", "price": 399 },
  { "name": "St. Botanica Bulgarian Rose Otto Glow Moisturizer", "price": 699 },
  { "name": "Simple Replenishing Rich Moisturiser", "price": 759 },
  { "name": "Mcaffeine Ceramide Intense Barrier Repair Cream", "price": 299 },
  { "name": "Clinique Moisture Surge Intense Hydrator", "price": 1200 },
  { "name": "The Body Care Aloe Vera Gel Moisturizer", "price": 349 },
  { "name": "Neutrogena Deep Clean Facial Cleanser", "price": 396 },
  { "name": "Cetaphil Gentle Skin Cleanser", "price": 281 },
  { "name": "Mamaearth Rice Face Wash", "price": 259 },
  { "name": "Clean & Clear Foaming Face Wash", "price": 185 },
  { "name": "Lakmé Blush and Glow Strawberry Gel Face Wash", "price": 270 },
  { "name": "Pond’s Pure White Anti-Pollution Face Wash", "price": 400 },
  { "name": "WOW Apple Cider Vinegar Foaming Face Wash", "price": 295 },
  { "name": "Dermalogica Special Cleansing Gel", "price": 1050 },
  { "name": "Skinnable Gentle Cleanser", "price": 750 },
  { "name": "VLCC Skin Defense Face Wash", "price": 199 },
  { "name": "Aqualogica Detan+ Gentle Melt Exfoliator", "price": 349 },
  { "name": "CLARINS One-Step Gentle Exfoliating Cleanser", "price": 2300 },
  { "name": "Purifying Exfoliating Gel Face Scrub", "price": 1547 },
  { "name": "Just Herbs Apricot Sparkle Radiance Scrub", "price": 445 },
  { "name": "Nivea Gentle Exfoliating Scrub", "price": 299 },
  { "name": "St. Ives Apricot Face Scrub", "price": 280 },
  { "name": "Biotique Papaya Tan Removal Scrub", "price": 199 },
  { "name": "Lotus Herbals White Glow Oatmeal Scrub", "price": 275 },
  { "name": "Plum Green Tea Gentle Revival Scrub", "price": 325 },
  { "name": "Pilgrim Volcanic Lava Ash Face Scrub", "price": 395 },
  { "name": "Minimalist 10% Niacinamide Serum", "price": 569 },
  { "name": "The Derma Co 2% Kojic Acid Serum", "price": 438 },
  { "name": "Deconstruct 10% Vitamin C Serum", "price": 615 },
  { "name": "Foxtale 12% Niacinamide Serum", "price": 495 },
  { "name": "Plum 15% Vitamin C Serum", "price": 467 },
  { "name": "Pilgrim 25% AHA + BHA + PHA Peeling Solution", "price": 497 },
  { "name": "L'Oreal Paris Glycolic Bright Serum", "price": 434 },
  { "name": "Mamaearth Vitamin C Daily Glow Serum", "price": 342 },
  { "name": "Vilvah Milk Drops Brightening Serum", "price": 608 },
  { "name": "Minimalist 2% Hyaluronic Acid + PGA Serum", "price": 569 },
  { "name": "Dot & Key 10% Vitamin C + E Serum", "price": 429 },
  { "name": "Mamaearth Ultra Light Indian Sunscreen SPF 50", "price": 499 },
  { "name": "Novology Hydrating Sheer Sunscreen SPF 50", "price": 600 },
  { "name": "Uniqaya Tinted Sunscreen SPF 50 PA+++", "price": 899 },
  { "name": "Mcaffeine Glow Sun Drops SPF 50 PA++++", "price": 499 },
  { "name": "DR.RASHEL Vitamin C Gel Sunscreen SPF 50", "price": 275 },
  { "name": "Re'equil Ultra Matte Dry Touch Sunscreen Gel", "price": 550 },
  { "name": "La Shield Fisico SPF 50 Sunscreen Gel", "price": 630 },
  { "name": "Neutrogena Ultra Sheer Dry-Touch SPF 50+", "price": 675 },
  { "name": "Minimalist SPF 50 Sunscreen with Vitamin B5", "price": 599 },
  { "name": "Dot & Key Watermelon Cooling Sunscreen SPF 50", "price": 495 },
  { "name": "Plum Green Tea Clear Face Mask", "price": 490 },
  { "name": "Mamaearth Ubtan Face Mask", "price": 499 },
  { "name": "Dot & Key Vitamin C + E Face Mask", "price": 545 },
  { "name": "Pilgrim Red Vine Face Mask", "price": 450 },
  { "name": "Biotique Bio Milk Protein Whitening Mask", "price": 199 },
  { "name": "The Face Shop Real Nature Rice Face Mask", "price": 100 },
  { "name": "Innisfree Super Volcanic Pore Clay Mask", "price": 1100 },
  { "name": "Forest Essentials Facial Ubtan Multani Mitti", "price": 1250 },
  { "name": "Khadi Natural Herbal Face Pack", "price": 175 },
  { "name": "WOW Skin Science Activated Charcoal Face Mask", "price": 399 },
  { "name": "L'Oreal Paris Pure Clay Mask Detoxify", "price": 750 },
  { "name": "The Derma Co 2% Salicylic Acid Clay Mask", "price": 499 },
  { "name": "Foxtale Deep Hydration Face Mask", "price": 525 },
  { "name": "Minimalist Anti-Acne Clay Mask", "price": 599 },
  { "name": "Plum Chamomile & White Tea Glow Mask", "price": 475 },
  { "name": "Mamaearth Tea Tree Face Mask", "price": 499 },
  { "name": "Dot & Key Cica Calming Face Mask", "price": 545 },
  { "name": "Pilgrim Korean Beauty Clay Mask", "price": 495 },
  { "name": "The Face Shop Jeju Volcanic Lava Mask", "price": 950 },
  { "name": "Innisfree My Real Squeeze Mask - Aloe", "price": 100 },
  { "name": "Khadi Natural Neem & Tulsi Face Pack", "price": 175 },
  { "name": "WOW Skin Science Ubtan Face Mask", "price": 399 },
  { "name": "L'Oreal Paris Revitalift Crystal Micro-Essence Mask", "price": 120 },
  { "name": "The Derma Co 5% Niacinamide Sheet Mask", "price": 149 },
  { "name": "Foxtale Brightening Sheet Mask", "price": 125 },
  { "name": "Minimalist Vitamin C Sheet Mask", "price": 149 },
  { "name": "Plum Avocado Nourishing Mask", "price": 475 },
  { "name": "Mamaearth Vitamin C Face Mask", "price": 499 },
  { "name": "Dot & Key Glow Reviving Mask", "price": 545 },
  { "name": "Pilgrim Squalane Glow Mask", "price": 495 },
  { "name": "The Face Shop Real Nature Lemon Mask", "price": 100 },
  { "name": "Innisfree Super Volcanic Peel Off Mask", "price": 1100 },
  { "name": "Forest Essentials Facial Ubtan Narangi & Nagkesar", "price": 1250 },
  { "name": "Khadi Natural Rose & Sandal Face Pack", "price": 175 },
  { "name": "WOW Skin Science Vitamin C Clay Mask", "price": 399 },
  { "name": "L'Oreal Paris Pure Clay Mask Exfoliate", "price": 750 },
  { "name": "The Derma Co 10% Vitamin C Clay Mask", "price": 499 },
  { "name": "Foxtale Hydrating Clay Mask", "price": 525 },


  { "name": "Clinique Moisture Surge Intense 72H Hydrator 15ml", "price": 1200 },
  { "name": "Simple Replenishing Rich Moisturiser 125ml", "price": 799 },
  { "name": "Mcaffeine Ceramide Intense Barrier Repair Cream 50ml", "price": 299 },
  { "name": "The Body Care Aloe Vera Moisturizing Gel 500g", "price": 349 },
  { "name": "Dr. Sheth's Haldi & Hyaluronic Acid Moisturizer 50ml", "price": 499 },
  { "name": "Neutrogena Deep Clean Facial Cleanser 200ml", "price": 396 },
  { "name": "Dermalogica Special Cleansing Gel 50ml", "price": 1050 },
  { "name": "Skinnable Gentle Cleanser 100ml", "price": 750 },
  { "name": "Mamaearth Tea Tree Face Wash 100ml", "price": 259 },
  { "name": "Cetaphil Gentle Skin Cleanser 250ml", "price": 297 },
  { "name": "Clarins One-Step Gentle Exfoliating Cleanser 200ml", "price": 2300 },
  { "name": "Aqualogica Detan+ Gentle Melt Exfoliator 50g", "price": 349 },
  { "name": "Just Herbs Apricot Sparkle Radiance Scrub 100g", "price": 545 },
  { "name": "St. Ives Fresh Skin Apricot Scrub 170g", "price": 399 },
  { "name": "Minimalist AHA BHA 10% Exfoliating Serum 30ml", "price": 599 },
  { "name": "The Derma Co 30% AHA + 2% BHA Peeling Solution 30ml", "price": 599 },
  { "name": "Dr. Loretta Intense Replenishing Serum 30ml", "price": 4200 },
  { "name": "Glow Recipe Watermelon Glow Niacinamide Drops 30ml", "price": 2890 },
  { "name": "Paula's Choice 2% BHA Liquid Exfoliant 118ml", "price": 2450 },
  { "name": "Face Reality Barrier Balance Creamy Cleanser 177ml", "price": 1890 },
  { "name": "Eadem Cloud Cushion Plush Moisturizer 50ml", "price": 3200 },
  { "name": "EltaMD UV Clear Broad-Spectrum SPF 46 48g", "price": 2850 },
  { "name": "Mamaearth Ultra Light Indian Sunscreen SPF 50 80g", "price": 499 },
  { "name": "Novology Hydrating Sheer Sunscreen SPF 50 PA++++ 50ml", "price": 600 },
  { "name": "Uniqaya Tinted Sunscreen SPF 50 PA+++ 50ml", "price": 899 },
  { "name": "Mcaffeine Glow Sun Drops SPF 50 PA++++ 30ml", "price": 499 },
  { "name": "Dr. Rashel Vitamin C Gel Sunscreen SPF 50 PA+++ 50ml", "price": 275 },
  { "name": "RAS Luxury Oils 24K Gold Radiance Elixir Serum 15ml", "price": 2150 },
  { "name": "Soulflower Kumkumadi Tailam Oil Serum 30ml", "price": 1099 },
  { "name": "Blue Nectar Kumkumadi Tailam Face Oil 10ml", "price": 1120 },
  { "name": "Truhabit Kumkumadi Oil Serum 30ml", "price": 349 },
  { "name": "Bio Essence 24K Gold Skin Elixir Serum 30ml", "price": 1270 },
  { "name": "Shankara Ayurvedic Kumkumadi Oil 18ml", "price": 1716 },
  { "name": "Pilgrim 25% AHA + 2% BHA + 5% PHA Peeling Solution 30ml", "price": 497 },
  { "name": "Vilvah Milk Drops Brightening Serum 20ml", "price": 608 },
  { "name": "Foxtale 12% Niacinamide Serum 30ml", "price": 495 },
  { "name": "Dot & Key 10% Vitamin C + E Serum 20ml", "price": 429 },
  { "name": "Plix Vitamin C Guava Face Serum 20ml", "price": 649 },
  { "name": "Himalaya Dark Spot Clearing Turmeric Serum 30ml", "price": 325 },
  { "name": "Himalaya Brightening Vitamin C Serum 15ml", "price": 249 },
  { "name": "WishCare Super Bright C16 Vitamin C Serum 30ml", "price": 570 },
  { "name": "The Plant Fix Pineapple De-Pigmentation Serum 30ml", "price": 499 },
  { "name": "Hyphen Brightening Niacinamide + Kakadu Plum Serum 30ml", "price": 610 },
  { "name": "Dot & Key Strawberry Niacinamide Serum 30ml", "price": 521 },
  { "name": "Lakmé Absolute Perfect Radiance Serum 30ml", "price": 266 },
  { "name": "Pond's Bright Beauty Anti-Pigmentation Serum 28ml", "price": 272 },
  { "name": "Minimalist 2% Hyaluronic Acid + PGA Serum 30ml", "price": 569 },
  { "name": "Deconstruct Niacinamide + Alpha Arbutin Serum 30ml", "price": 559 },
  { "name": "ASAYA Melame Complex Pigmentation Serum 30ml", "price": 499 },



    
                  ],
                   "Hair Care": [
  
               { "name": "L'Oreal Paris Hyaluron Moisture Shampoo 650ml & Conditioner 180ml", "price": 1418 },
  { "name": "Dove Daily Shine Shampoo 1L & Hair Fall Rescue Conditioner 175ml", "price": 1716 },
  { "name": "L'Oreal Hyaluron Pure Rehydrating Shampoo & Conditioner 975ml", "price": 1448 },
  { "name": "L'Oreal Total Repair 5 Shampoo 340ml & Conditioner 180ml", "price": 738 },
  { "name": "L'Oreal Hyaluron Moisture Shampoo 340ml + Conditioner + Hair Cream", "price": 1267 },
  { "name": "Bare Anatomy Anti Hair Fall Shampoo 250ml", "price": 446 },
  { "name": "Matrix Opti.Care Smooth Straight Shampoo 200ml", "price": 385 },
  { "name": "Sebamed Anti Dandruff Shampoo 200ml", "price": 680 },
  { "name": "Biolage Scalppure Anti-Dandruff Shampoo 200ml", "price": 389 },
  { "name": "BBlunt Hair Fall Control Shampoo 300ml", "price": 290 },
  { "name": "Biolage Smoothproof Anti-Frizz Shampoo 200ml", "price": 256 },
  { "name": "Bare Anatomy Ultra Smoothing Shampoo 250ml", "price": 498 },
  { "name": "BBLUNT Intense Moisture Shampoo 300ml", "price": 337 },
  { "name": "L'Oreal Inforcer Shampoo with Vitamin B6 & Biotin 300ml", "price": 742 },
  { "name": "Schwarzkopf Spa Essence Nourishing Shampoo 1000ml", "price": 877 },
  { "name": "Biolage Fiberstrong Anti-Breakage Shampoo 200ml", "price": 450 },
  { "name": "Biolage Hydrasource Anti-Dryness Shampoo 200ml", "price": 285 },
  { "name": "Matrix Opti.Repair Liquid Protein Shampoo 200ml", "price": 435 },
  { "name": "OGX Biotin & Collagen Volumizing Shampoo 385ml", "price": 713 },
  { "name": "Meera Hairfall Care Shampoo 180ml", "price": 163 },
  { "name": "Trigaine Anti-Frizz Hair Serum 30ml", "price": 552 },
  { "name": "Dr. Sheths Rosemary & Redensyl Hair Serum In Oil 30ml", "price": 849 },
  { "name": "Beardo Hair Serum with Argan & Almond Oil 50ml x 2", "price": 590 },
  { "name": "Pure Roots Hair Serum with Argan Oil (Pack of 3)", "price": 499 },
  { "name": "Curl Rhythm Nourish & Radiant Hair Oil Serum (3 Pack)", "price": 4494 },
  { "name": "Livon Hair Serum 200ml", "price": 279 },
  { "name": "L'Oreal Extraordinary Oil Hair Serum 100ml", "price": 402 },
  { "name": "Mamaearth Onion Hair Serum 100ml", "price": 202 },
  { "name": "Pilgrim Hair Growth Serum with Redensyl & Anagain 30ml", "price": 463 },
  { "name": "Hamsa Radiance Hair Growth Serum 50ml", "price": 867 },
  { "name": "L'Oreal Hyaluron Moisture Hair Serum 80ml", "price": 318 },
  { "name": "KT Professional Hair Growth Serum with Redensyl 50ml", "price": 489 },
  { "name": "Melophil Hair Growth Serum with Rosemary & Anagain 30ml", "price": 516 },
  { "name": "WishCare Hair Growth Serum Concentrate 30ml", "price": 689 },
  { "name": "Bajaj Almond Drops Hair Serum 100ml", "price": 176 },
  { "name": "Biolage 6-in-1 Hair Serum 100ml", "price": 315 },
  { "name": "Biotique Mountain Ebony Anti Hair Fall Serum 120ml", "price": 142 },
  { "name": "Gatsby Japan Hair Serum 100ml", "price": 399 },
  { "name": "Streax Vitariche Gloss Hair Serum 115ml", "price": 278 },
  { "name": "Livon Professional Smoothening Serum 100ml", "price": 198 },
  { "name": "Mamaearth Onion Hair Oil 200ml", "price": 499 },
  { "name": "Mamaearth Bhring Amla Hair Oil 250ml", "price": 499 },
  { "name": "Jovees Herbal Hair Growth Treatment Oil 100ml", "price": 295 },
  { "name": "Gans 24 Herbs Hair Treatment Serum 50ml", "price": 799 },
  { "name": "Jovees Keratin Hair Balance Shampoo 300ml", "price": 415 },
  { "name": "Indus Valley Gel Hair Color (400ml)", "price": 1049 },
  { "name": "Garnier Color Naturals Crème Hair Color Black & Brown Combo", "price": 414 },
  { "name": "Schwarzkopf Simply Color Permanent Hair Color 142.5ml", "price": 749 },
  { "name": "Color Beaute Mix Fruit Wine Gel Hair Color 1000ml", "price": 479 },
  { "name": "Garnier Color Naturals Creme Hair Color Brown", "price": 229 },
  { "name": "L'Oreal Paris Casting Creme Gloss Hair Color", "price": 550 },
  { "name": "Godrej Expert Rich Crème Hair Color", "price": 150 },
  { "name": "BBLUNT Salon Secret High Shine Hair Color", "price": 193 },
  { "name": "Biotique Bio Herbcolor Hair Color", "price": 192 },
  { "name": "Revlon Top Speed Hair Color", "price": 435 },
  { "name": "Streax Cream Hair Color", "price": 125 },
  { "name": "Clairol Natural Instincts Hair Color", "price": 900 },
  { "name": "Indus Valley Organic Hair Color", "price": 575 },
  { "name": "Wella Koleston Hair Color", "price": 900 },
  { "name": "L'Oreal Paris Total Repair 5 Hair Mask", "price": 549 },
  { "name": "Mamaearth Rosemary Hair Mask", "price": 599 },
  { "name": "Pilgrim Argan Oil Hair Mask", "price": 695 },
  { "name": "Biolage Deep Treatment Hair Mask", "price": 650 },
  { "name": "Streax Professional Hair Mask", "price": 510 },
  { "name": "Bare Anatomy Hair Mask with Niacinamide", "price": 595 },
  { "name": "BBLUNT Intense Moisture Hair Mask", "price": 399 },
  { "name": "L'Oreal Paris Hyaluron Moisture Night Cream", "price": 419 },
  { "name": "Mamaearth Rosemary Hair Growth Combo", "price": 613 },
  { "name": "Pilgrim Hairfall Control Combo (Conditioner + Serum)", "price": 895 },
  { "name": "Biotique Hair Color & Conditioner Combo", "price": 322 },
  { "name": "Indulekha Bringha Hairfall Control Shampoo", "price": 454 },
  { "name": "Clinic Plus Strong & Long Shampoo", "price": 463 },


  { "name": "L'Oréal Paris Hyaluron Moisture Shampoo 650ml & Conditioner 180ml Combo", "price": 1418 },
  { "name": "Dove Daily Shine Shampoo 1L & Hair Fall Rescue Conditioner 175ml", "price": 1716 },
  { "name": "L'Oréal Hyaluron Pure Rehydrating Shampoo & Conditioner 975ml", "price": 1448 },
  { "name": "L'Oréal Total Repair 5 Shampoo 340ml & Conditioner 180ml", "price": 738 },
  { "name": "L'Oréal Hyaluron Moisture Shampoo 340ml + Conditioner 180ml + Hair Cream 180ml", "price": 1267 },
  { "name": "Trigaine Anti-Frizz Leave-In Hair Serum 30ml", "price": 552 },
  { "name": "Dr. Sheth's Rosemary & Redensyl Hair Serum In Oil 30ml", "price": 849 },
  { "name": "Beardo Hair Serum with Argan & Almond Oil 50ml x 2", "price": 590 },
  { "name": "Pure Roots Hair Serum with Argan Oil & Vitamin E 100ml x 3", "price": 499 },
  { "name": "Curl Rhythm Nourish & Radiant Hair Oil Serum 3 Pack", "price": 4494 },
  { "name": "Mamaearth Onion Hair Styling Cream for Men 100ml", "price": 299 },
  { "name": "Dear Barber Shaping Cream with Avocado Oil 20ml", "price": 775 },
  { "name": "Matte Texture Hair Styling Cream for Men 4oz", "price": 2477 },
  { "name": "Style & Care Shiny Strong Hold Hair Spray 200ml", "price": 4097 },
  { "name": "Alaparte Moroccan Hydrating Styling Cream 100ml", "price": 3319 },
  { "name": "Indus Valley Gel Hair Color (6 Shades) 400ml", "price": 1049 },
  { "name": "Garnier Color Naturals Crème Hair Color Natural Black 70ml + 60g", "price": 414 },
  { "name": "Schwarzkopf Simply Color Permanent Hair Color Hazelnut Brown 142.5ml", "price": 749 },
  { "name": "Color Beaute Mix Fruit Wine Natural Gel Hair Color 1000ml", "price": 479 },
  { "name": "Garnier Color Naturals Crème Hair Color Brown 108ml", "price": 229 },
  { "name": "Mamaearth Onion Hair Oil 200ml", "price": 499 },
  { "name": "Jovees Herbal Hair Growth Treatment Oil 100ml", "price": 295 },
  { "name": "Jovees Keratin Hair Balance Shampoo 300ml", "price": 415 },
  { "name": "Ultimate Hair Treatment Kit (Shampoo, Conditioner, Serum, Spa)", "price": 1099 },
  { "name": "Jovees Organic Onion Hair Oil 100ml", "price": 295 },
  { "name": "Bare Anatomy Anti Hair Fall Shampoo 250ml", "price": 446 },
  { "name": "Sebamed Anti Dandruff Shampoo 200ml", "price": 680 },
  { "name": "Matrix Opti.Care Smooth Straight Shampoo 200ml", "price": 385 },
  { "name": "L'Oréal Xtenso Care Shampoo 250ml", "price": 621 },
  { "name": "L'Oréal Serie Expert Absolut Repair Serum 90ml", "price": 745 },
  { "name": "L'Oréal Serie Expert Density Advanced Shampoo 300ml", "price": 745 },
  { "name": "Just Herbs 8-in-1 Root Nourishing Shampoo 200ml", "price": 451 },
  { "name": "Biolage Scalppure Anti-Dandruff Shampoo 200ml", "price": 389 },
  { "name": "BBlunt Hair Fall Control Shampoo 300ml", "price": 290 },
  { "name": "Biolage Smoothproof Anti-Frizz Shampoo 200ml", "price": 285 },
  { "name": "Bare Anatomy Ultra Smoothing Shampoo 250ml", "price": 498 },
  { "name": "BBLUNT Intense Moisture Shampoo 300ml", "price": 337 },
  { "name": "L'Oréal Serie Expert Inforcer Shampoo 300ml", "price": 742 },
  { "name": "Schwarzkopf Spa Essence Nourishing Shampoo 1000ml", "price": 877 },
  { "name": "Mildy Everyday Shampoo 3 x 100ml", "price": 649 },
  { "name": "Biolage Fiberstrong Anti-Breakage Shampoo 200ml", "price": 450 },
  { "name": "Biolage Hydrasource Anti-Dryness Shampoo 200ml", "price": 285 },
  { "name": "Matrix Opti.Repair Liquid Protein Shampoo 200ml", "price": 435 },
  { "name": "OGX Biotin & Collagen Volumizing Shampoo 385ml", "price": 713 },
  { "name": "Meera Hairfall Care Shampoo Shikakai 180ml", "price": 163 },
  { "name": "Biotique Green Apple Shine & Glow Shampoo 650ml", "price": 322 },
  { "name": "Indulekha Bringha Shampoo 580ml", "price": 454 },
  { "name": "Clinic Plus Strong & Long Shampoo 1L", "price": 463 },
  { "name": "Mamaearth Rosemary Hair Growth Oil 250ml", "price": 304 },
  { "name": "Streax Canvoline Shampoo 300ml", "price": 484 },
  { "name": "Nyle Volume Enhance Shampoo 1000ml", "price": 368 },
  { "name": "Imxia Plus Hair Strengthening Shampoo 150ml", "price": 400 },
  { "name": "Naturali Hairfall Control Shampoo 200ml", "price": 329 },
  { "name": "Khadi Natural Amla & Bhringraj Shampoo 420ml", "price": 245 },
  { "name": "Mamaearth Rosemary Hair Scalp Serum 100ml", "price": 463 },
  { "name": "Minimalist Hair Growth Serum 50ml", "price": 489 },
  { "name": "Kérastase Genesis Anti-Hair Fall Serum 90ml", "price": 1242 },
  { "name": "Naturali Hairfall Control Shampoo 200ml", "price": 329 },
  { "name": "Biotique Bio Kelp Protein Shampoo 200ml", "price": 175 },
  { "name": "Mamaearth Onion Hair Mask 200ml", "price": 599 },
  { "name": "Pilgrim Hair Growth Serum with Redensyl 50ml", "price": 463 },
  { "name": "WishCare Hair Growth Serum 30ml", "price": 689 },
  { "name": "Avimee Herbal Scalptone Hair Growth Serum 25ml", "price": 531 },
  { "name": "Streax Vitariche Gloss Hair Serum 115ml", "price": 278 },
  { "name": "Livon Hair Serum with Vitamin E & Argan Oil 100ml", "price": 201 },
  { "name": "Biolage 6-in-1 Hair Serum 100ml", "price": 315 },
  { "name": "Mamaearth Rosemary Hair Mask 200g", "price": 499 },
  { "name": "TNW Neem Oil & Black Seed Hair Serum Combo", "price": 602 },
  { "name": "Bayrum Hair Care Combo Kit (Oil, Shampoo, Conditioner, Serum)", "price": 1230 },
  { "name": "Soulflower Rosemary Essential Oil & Redensyl Serum Combo", "price": 799 },
  { "name": "Pilgrim Argan Oil Conditioner & Hair Growth Serum Combo", "price": 895 },


  { "name": "L'Oréal Paris Hyaluron Moisture Shampoo 650ml & Conditioner 180ml Combo", "price": 1418 },
  { "name": "Dove Daily Shine Shampoo 1L & Hair Fall Rescue Conditioner 175ml", "price": 1716 },
  { "name": "L'Oréal Hyaluron Pure Rehydrating Shampoo & Conditioner 975ml", "price": 1448 },
  { "name": "L'Oréal Total Repair 5 Shampoo 340ml & Conditioner 180ml", "price": 738 },
  { "name": "L'Oréal Hyaluron Moisture Shampoo 340ml + Conditioner 180ml + Hair Cream 180ml", "price": 1267 },
  { "name": "Trigaine Anti-Frizz Leave-In Hair Serum 30ml", "price": 552 },
  { "name": "Dr. Sheth's Rosemary & Redensyl Hair Serum In Oil 30ml", "price": 849 },
  { "name": "Beardo Hair Serum with Argan & Almond Oil 50ml x 2", "price": 590 },
  { "name": "Pure Roots Hair Serum with Argan Oil (Pack of 3) 100ml", "price": 499 },
  { "name": "Curl Rhythm Nourish & Radiant Hair Oil Serum 3 Pack", "price": 4494 },
  { "name": "L'Oréal Extraordinary Oil Hair Serum 100ml", "price": 402 },
  { "name": "Mamaearth Onion Hair Serum 100ml", "price": 202 },
  { "name": "Pilgrim Hair Growth Serum with Redensyl & Anagain 30ml", "price": 463 },
  { "name": "Biolage 6-in-1 Hair Serum with Avocado Oil 100ml", "price": 315 },
  { "name": "Streax Vitariche Gloss Hair Serum 115ml", "price": 278 },
  { "name": "Livon Professional Smoothening Serum 100ml", "price": 198 },
  { "name": "Bare Anatomy Anti Hair Fall Shampoo 250ml", "price": 446 },
  { "name": "Sebamed Anti Dandruff Shampoo 200ml", "price": 680 },
  { "name": "Matrix Opti.Care Smooth Straight Shampoo 350ml", "price": 580 },
  { "name": "OGX Biotin & Collagen Volumizing Shampoo 385ml", "price": 713 },
  { "name": "Meera Hairfall Care Shampoo with Shikakai 180ml", "price": 163 },
  { "name": "Just Herbs 8-in-1 Amla Neem Hair Fall Control Shampoo 200ml", "price": 451 },
  { "name": "Biolage Scalppure Anti-Dandruff Shampoo 200ml", "price": 389 },
  { "name": "BBlunt Hair Fall Control Shampoo with Pea Protein 300ml", "price": 290 },
  { "name": "Biolage Smoothproof Anti-Frizz Shampoo 200ml", "price": 285 },
  { "name": "Bare Anatomy Ultra Smoothing Shampoo 250ml", "price": 498 },
  { "name": "BBLUNT Intense Moisture Shampoo with Jojoba & Vitamin E 300ml", "price": 337 },
  { "name": "Schwarzkopf Spa Essence Nourishing Shampoo 1000ml", "price": 877 },
  { "name": "Biolage Fiberstrong Anti-Breakage Shampoo 200ml", "price": 450 },
  { "name": "Biolage Hydrasource Anti-Dryness Shampoo 200ml", "price": 285 },
  { "name": "Matrix Opti.Repair Liquid Protein Shampoo 200ml", "price": 435 },
  { "name": "Indus Valley Gel Hair Color (6 Shades) 400ml", "price": 1049 },
  { "name": "Garnier Color Naturals Crème Hair Color Shade 1 & 5 Combo", "price": 414 },
  { "name": "Schwarzkopf Simply Color Permanent Hair Color Hazelnut Brown", "price": 749 },
  { "name": "Color Beaute Mix Fruit Wine Natural Gel Hair Color 1000ml", "price": 479 },
  { "name": "Garnier Color Naturals Creme Hair Color 4 Brown", "price": 229 },
  { "name": "L'Oréal Casting Crème Gloss Hair Color 87.5g + 72ml", "price": 550 },
  { "name": "Revlon Colorsilk Hair Color Natural Black 91ml", "price": 435 },
  { "name": "Streax Ultralights Highlighting Kit", "price": 399 },
  { "name": "Biotique Bio Herbcolor Conditioning Hair Color 50g + 110ml", "price": 399 },
  { "name": "Godrej Expert Rich Creme Hair Color Natural Black", "price": 155 },
  { "name": "Wella Koleston Hair Color Cream Dark Brown 303", "price": 900 },
  { "name": "Clairol Natural Instincts Hair Color", "price": 499 },
  { "name": "Indus Valley Bio Organic Hair Color", "price": 575 },
  { "name": "Matrix Socolor Permanent Cream Hair Color", "price": 320 },
  { "name": "L'Oréal Paris Total Repair 5 Hair Mask 200ml", "price": 499 },
  { "name": "Mamaearth Onion Hair Oil 200ml", "price": 499 },
  { "name": "Jovees Herbal Hair Growth Treatment Oil 100ml", "price": 295 },
  { "name": "Jovees Keratin Hair Balance Shampoo 300ml", "price": 415 },
  { "name": "Gans 24 Herbs Intensive Hair Treatment Serum 50ml", "price": 799 },
  { "name": "Ultimate Hair Treatment Kit (Shampoo, Conditioner, Serum, Spa)", "price": 1099 },
  { "name": "Biolage Deep Treatment Pack for Dry Hair 100ml", "price": 350 },
  { "name": "Bare Anatomy Hair Treatment Mask for Frizz Control 250ml", "price": 595 },
  { "name": "Pilgrim Argan Oil Hair Mask 200ml", "price": 450 },
  { "name": "Mamaearth Rice Water Hair Mask 200ml", "price": 499 },
  { "name": "Streax Professional Hair Spa Nourishment Kit", "price": 699 },
  { "name": "Biotique Bio Musk Root Hair Pack 230g", "price": 250 },
  { "name": "Indulekha Bringha Hair Treatment Oil 100ml", "price": 432 },
  { "name": "Khadi Natural Herbal Hair Treatment Powder 100g", "price": 199 },
  { "name": "Godrej Professional Hair Treatment Mask 200ml", "price": 499 },
  { "name": "L'Oréal Professionnel Hair Spa Detoxifying Creambath 490g", "price": 899 },
  { "name": "Wella Professionals Fusion Intense Repair Mask 150ml", "price": 850 },
  { "name": "Schwarzkopf Bonacure Peptide Repair Rescue Treatment 200ml", "price": 950 },
  { "name": "Matrix Biolage Smoothproof Deep Smoothing Serum 100ml", "price": 350 },
  { "name": "Mamaearth Rosemary Hair Growth Serum 50ml", "price": 399 },
  { "name": "Pilgrim Advanced Hair Growth Serum Roll-On 10ml", "price": 90 },
  { "name": "WishCare Hair Growth Serum Concentrate 30ml", "price": 689 },
  { "name": "Avimee Herbal Scalptone Hair Growth Serum 25ml", "price": 531 },
  { "name": "ThriveCo Anti-Grey Hair Prime Serum 50ml", "price": 625 },
  { "name": "KT Professional Advanced Hair Growth Serum 50ml", "price": 489 },
  { "name": "Dr Batra's Anti Dandruff Hair Serum 200ml", "price": 399 },
  { "name": "Bayrum Hair Care Combo Kit (Oil, Shampoo, Conditioner, Serum)", "price": 1230 },

                  ],
                    "Make-up": [
  
               { "name": "Lakmé Absolute Matte Melt Lip Color", "price": 1499 },
  { "name": "Maybelline Superstay Matte Ink", "price": 1299 },
  { "name": "Colorbar Velvet Matte Lipstick", "price": 999 },
  { "name": "Sugar Smudge Me Not Liquid Lipstick", "price": 499 },
  { "name": "Revlon Super Lustrous Lipstick", "price": 899 },
  { "name": "Faces Canada Weightless Creme Lipstick", "price": 999 },
  { "name": "Nykaa So Matte Lipstick", "price": 879 },
  { "name": "Plum Matterrific Lipstick", "price": 435 },
  { "name": "MyGlamm LIT Liquid Matte Lipstick", "price": 675 },
  { "name": "L'Oréal Paris Color Riche Moist Matte", "price": 1499 },
  { "name": "Elle 18 Color Pops Matte Lipstick", "price": 4099 },
  { "name": "Swiss Beauty Pure Matte Lipstick", "price": 1099 },
  { "name": "Blue Heaven Hyperstay Matte Lipstick", "price": 1499 },
  { "name": "Just Herbs Ayurvedic Lipstick Kit", "price": 1299 },
  { "name": "Renee Madness PH Lipstick", "price": 1799 },
  { "name": "Bella Vita Organic Mini Lipstick Set", "price": 1599 },
  { "name": "Mars Long Lasting Crayon Lipstick", "price": 1499 },
  { "name": "Tint Cosmetics Brick Red Lipgloss", "price": 499 },
  { "name": "Swiss Beauty Gloss Me Lip Gloss", "price": 1499 },
  { "name": "Glossier Crystal Clear Lip Gloss", "price": 997 },
  { "name": "Baked Beauty Iced Gloss Lip Gloss", "price": 499 },
  { "name": "Glamveda LipSerum Gloss Pack", "price": 999 },
  { "name": "Fenty Beauty Gloss Bomb", "price": 499 },
  { "name": "MAC Lipglass", "price": 556 },
  { "name": "NARS Lip Gloss", "price": 565 },
  { "name": "Broadway Vita-Lip Gloss", "price": 546 },
  { "name": "NYX Butter Gloss", "price": 324 },
  { "name": "Kylie Cosmetics Gloss", "price": 545 },
  { "name": "Buxom Holographic Lip Gloss", "price": 499 },
  { "name": "Bobbi Brown Crushed Oil-Infused Gloss", "price": 1499 },
  { "name": "Tower 28 ShineOn Lip Jelly", "price": 499 },
  { "name": "Lawless Forget The Filler Gloss", "price":1299 },
  { "name": "Anastasia Beverly Hills Lip Gloss", "price": 499 },
  { "name": "Maybelline Lifter Gloss", "price": 1499 },
  { "name": "Patrick Ta Major Volume Gloss", "price": 499 },
  { "name": "Milk Makeup Odyssey Lip Gloss", "price": 1499 },
  { "name": "Insight Intense Gel Lip Liner", "price": 1288 },
  { "name": "Lakmé Lip Definer", "price": 676 },
  { "name": "Colorbar Definer Lip Liner", "price": 1299 },
  { "name": "Sugar Lipping On The Edge Lip Liner", "price":1499 },
  { "name": "MyGlamm LIT Lip Liner Pencil", "price": 499 },
  { "name": "Swiss Beauty Lip Liner Set", "price": 1499 },
  { "name": "Plum Lip Liner Pencil", "price": 4199 },
  { "name": "Renee Lip Liner Pencil", "price": 499 },
  { "name": "Mars Edge of Desire Lip Liner", "price": 4199 },
  { "name": "Nivea Blackberry Shine Lip Balm", "price": 1499 },
  { "name": "Maybelline Baby Lips Lip Balm", "price": 4199 },
  { "name": "Sebamed Lip Defense Balm", "price": 1499 },
  { "name": "Mamaearth Moisture Matte Lip Balm", "price": 4199 },
  { "name": "Dot & Key Gloss Boss Lip Balm", "price": 1499 },
  { "name": "Minimalist Vitamin C Lip Balm", "price": 499 },
  { "name": "Plum Candy Melts Lip Balm", "price": 1499 },
  { "name": "Laneige Lip Glowy Balm", "price": 676 },
  { "name": "Biotique Fruit Whitening Lip Balm", "price": 676 },
  { "name": "Just Herbs Lip Nourishing Balm", "price": 499 },
  { "name": "Lakmé Absolute Gel Stylist Nail Polish", "price": 499 },
  { "name": "Colorbar Luxe Nail Lacquer", "price": 3340 },
  { "name": "Nykaa Matte Nail Enamel", "price": 499 },
  { "name": "Juice One Coat Nail Polish", "price": 1499 },
  { "name": "Elle 18 Nail Pops", "price":1499 },
  { "name": "Sugar POP Nail Lacquer", "price": 4199 },
  { "name": "Insight Intense Nail Polish", "price": 1499 },
  { "name": "Blue Heaven Hypergel Nail Paint", "price": 499 },
  { "name": "LoveChild Masaba Nail Polish", "price": 499 },
  { "name": "Faces Canada Splash Nail Enamel", "price": 1499 },
  { "name": "Revlon Top Speed Nail Enamel", "price": 599 },
  { "name": "OPI Nail Lacquer", "price": 499 },
  { "name": "Swiss Beauty Gel Effect Nail Lacquer", "price": 633 },
  { "name": "Miniso Glam Nail Polish", "price": 499 },
  { "name": "Bella Voste Nail Polish", "price": 556 },
  { "name": "Lakmé Nail Polish Remover", "price": 499 },
  { "name": "Colorbar Nail Polish Remover Wipes", "price": 499 },
  { "name": "Nykaa Nail Polish Remover", "price": 499 },
  { "name": "Swiss Beauty Nail Polish Remover", "price": 568 },
  { "name": "Faces Canada Nail Remover Pads", "price": 499 },
  { "name": "Elle 18 Nail Polish Remover", "price": 789 },
  { "name": "Sugar Nail Polish Remover", "price": 499 },
  { "name": "Mars Nail Polish Remover", "price": 635 },
  { "name": "Miniso Nail Polish Remover", "price": 499 },
  { "name": "Nykaa Nail Art Stickers", "price": 695 },
  { "name": "Colorbar Nail Art Kit", "price": 499 },
  { "name": "Swiss Beauty Nail Art Accessories", "price": 499 },

  { "name": "ASAYA Velvet Matte Foundation 30ml", "price": 549 },
  { "name": "ASAYA Dewy Glow Primer 25ml", "price": 399 },
  { "name": "ASAYA Radiance Concealer Stick", "price": 299 },
  { "name": "ASAYA Blush Bloom Compact - Rose", "price": 349 },
  { "name": "ASAYA Contour & Highlight Duo", "price": 499 },
  { "name": "ASAYA Loose Setting Powder - Translucent", "price": 299 },
  { "name": "ASAYA Skin Tint Serum 30ml", "price": 599 },
  { "name": "ASAYA Matte Finish BB Cream 40ml", "price": 349 },
  { "name": "ASAYA Glow Mist Spray 50ml", "price": 299 },
  { "name": "ASAYA Pore Minimizer Primer Gel", "price": 399 },
  { "name": "ASAYA Brow Sculpting Pencil - Dark Brown", "price": 199 },
  { "name": "ASAYA Brow Pomade - Espresso", "price": 249 },
  { "name": "ASAYA Brow Gel - Clear", "price": 199 },
  { "name": "ASAYA Eyeshadow Palette - Sunset Hues", "price": 599 },
  { "name": "ASAYA Eyeshadow Quad - Smoky", "price": 349 },
  { "name": "ASAYA Liquid Eyeliner - Jet Black", "price": 199 },
  { "name": "ASAYA Gel Eyeliner Pot - Charcoal", "price": 249 },
  { "name": "ASAYA Kajal Pencil - Intense Black", "price": 149 },
  { "name": "ASAYA Waterproof Mascara - Volume Boost", "price": 299 },
  { "name": "ASAYA Lash Curling Mascara", "price": 299 },
  { "name": "ASAYA Eye Primer Base", "price": 199 },
  { "name": "ASAYA Lipstick - Crimson Kiss", "price": 249 },
  { "name": "ASAYA Lipstick - Nude Whisper", "price": 249 },
  { "name": "ASAYA Lipstick - Berry Crush", "price": 249 },
  { "name": "ASAYA Lip Gloss - Clear Shine", "price": 199 },
  { "name": "ASAYA Lip Gloss - Coral Pop", "price": 199 },
  { "name": "ASAYA Lip Liner - Ruby Red", "price": 149 },
  { "name": "ASAYA Lip Balm - Minty Fresh", "price": 99 },
  { "name": "ASAYA Lip Balm - Rose Tint", "price": 99 },
  { "name": "ASAYA Matte Liquid Lipstick - Wine", "price": 299 },
  { "name": "ASAYA Matte Liquid Lipstick - Peach", "price": 299 },
  { "name": "ASAYA Lip Plumper Serum", "price": 349 },
  { "name": "ASAYA Nail Polish - Classic Red", "price": 149 },
  { "name": "ASAYA Nail Polish - Nude Beige", "price": 149 },
  { "name": "ASAYA Nail Polish - Midnight Blue", "price": 149 },
  { "name": "ASAYA Nail Polish - Lavender Mist", "price": 149 },
  { "name": "ASAYA Nail Polish - Metallic Gold", "price": 149 },

  { "name": "Maybelline Fit Me Matte+Poreless Foundation", "price": 499 },
  { "name": "Lakme Absolute White Intense Concealer Stick", "price": 499 },
  { "name": "Swiss Beauty Pro Blusher & Highlighter", "price": 499 },
  { "name": "Blue Heaven Diamond Blush", "price": 499 },
  { "name": "Faces Canada Ultime Pro HD Finishing Touch Powder", "price": 654 },
  { "name": "Insight Cosmetics Pro Concealer Palette", "price": 499 },
  { "name": "SUGAR Contour De Force Mini Blush", "price": 564 },
  { "name": "Coloressence Aqua Makeup Base Foundation", "price": 654 },
  { "name": "Mars Wonder Cover Matte Liquid Concealer", "price": 565 },
  { "name": "FACES CANADA High Cover Concealer", "price": 499 },

  { "name": "Maybelline Colossal Mascara", "price": 767 },
  { "name": "Lakme Eyeconic Kajal", "price": 754 },
  { "name": "Swiss Beauty Ultimate Eyeshadow Palette", "price": 789 },
  { "name": "Mars Fantasy Face Palette", "price": 990 },
  { "name": "SUGAR POP Eyeliner", "price": 678 },
  { "name": "Colorbar Infinite 24Hrs Eyeliner", "price": 888},
  { "name": "Blue Heaven Walk Free Mascara", "price": 559 },
  { "name": "FACES CANADA Brow Defining Pencil", "price": 399 },
  { "name": "Insight Cosmetics Eyebrow Pencil", "price": 899 },
  { "name": "Mars Eyebrow Definer", "price": 999 },

  { "name": "Maybelline Color Sensational Lipstick", "price": 1499 },
  { "name": "Lakme Enrich Matte Lipstick", "price": 899 },
  { "name": "Swiss Beauty Non-Transfer Lipstick", "price": 499 },
  { "name": "SUGAR POP Lip Gloss", "price": 699 },
  { "name": "Blue Heaven Hyperstay Lip Gloss", "price": 899 },
  { "name": "FACES CANADA Lip Liner Pencil", "price": 489 },
  { "name": "Insight Cosmetics Lip Balm", "price": 699 },
  { "name": "Mars Matte Lip Crayon", "price": 499 },
  { "name": "Coloressence Lip Balm", "price": 599 },
  { "name": "Colorbar Definer Lip Liner", "price": 499 },

  { "name": "Maybelline Color Show Nail Polish", "price": 499 },
  { "name": "Lakme True Wear Nail Color", "price": 1499 },
  { "name": "Swiss Beauty Nail Lacquer", "price": 799 },
  { "name": "SUGAR POP Nail Polish", "price": 1499 },
  { "name": "Blue Heaven Nail Paint", "price": 1009 },
  { "name": "FACES CANADA Splash Nail Enamel", "price": 939 },
  { "name": "Insight Cosmetics Nail Polish Remover", "price": 989 },
  { "name": "Mars Nail Polish Remover Pads", "price": 789 },
  { "name": "Coloressence Nail Polish Remover", "price": 599 },
  { "name": "Colorbar Nail Lacquer Remover", "price": 499 },

  { "name": "Nykaa Nail Art Stickers", "price": 999 },
  { "name": "Mars Nail Art Kit", "price": 589 },
  { "name": "Swiss Beauty Nail Art Accessories", "price": 809 },
  { "name": "Blue Heaven Nail Art Pens", "price": 400 },
  { "name": "FACES CANADA Nail Art Tools", "price": 899 },
  { "name": "Insight Nail Art Brushes", "price": 789 },
  { "name": "Coloressence Nail Art Glitter", "price": 499 },
  { "name": "Colorbar Nail Art Foils", "price": 659 },
  { "name": "SUGAR POP Nail Art Stickers", "price": 559 },
  { "name": "Lakme Nail Art Kit", "price": 779 },

  { "name": "Mars Liquid Highlighter", "price": 889 },
  { "name": "Coloressence Shimmer Brick Highlighter", "price": 409 },
  { "name": "Colorbar Glow Crazy Highlighter", "price": 899 },
  { "name": "SUGAR POP Glow Blush Highlighter", "price": 799 },
  { "name": "Blue Heaven Strobe & Shine Highlighter", "price": 699 },
  { "name": "FACES CANADA Strobe Cream", "price": 299 },
  { "name": "Insight Cosmetics Glow Highlighter", "price": 399 },
  { "name": "Swiss Beauty Baked Highlighter", "price": 599 },
  { "name": "Lakme Absolute Highlighter", "price": 499 },
  { "name": "Maybelline Master Chrome Highlighter", "price": 799 },


  { "name": "Maybelline Master Chrome Highlighter", "price": 599 },
  { "name": "Swiss Beauty Baked Blusher & Highlighter", "price": 399 },
  { "name": "Faces Canada Ultime Pro Highlighter", "price": 799 },
  { "name": "Colorbar Radiant Glow Face Illuminator", "price": 850 },
  { "name": "Sugar Contour De Force Mini Highlighter", "price": 399 },
  { "name": "Revlon Skinlights Prismatic Highlighter", "price": 950 },
  { "name": "L'Oreal Paris True Match Lumi Glow", "price": 899 },
  { "name": "Nykaa Glow Goals Shimmer Brick", "price": 699 },
  { "name": "Wet n Wild MegaGlo Highlighting Powder", "price": 599 },
  { "name": "PAC Baked Highlighter", "price": 795 },
  { "name": "Makeup Revolution Highlighter Reloaded", "price": 650 },
  { "name": "Miss Claire Illuminator", "price": 325 },
  { "name": "Insight Cosmetics Highlighter", "price": 250 },
  { "name": "Blue Heaven Glow & Shine Highlighter", "price": 175 },
  { "name": "Renee Fab 3-in-1 Highlighter Stick", "price": 449 },
  { "name": "Lotus Herbals Ecostay Highlighter", "price": 675 },
  { "name": "Coloressence Shimmer Brick", "price": 299 },
  { "name": "MyGlamm Spotlight Illuminating Liquid", "price": 595 },
  { "name": "Milani Strobelight Instant Glow", "price": 1250 },
  { "name": "Bobbi Brown Highlighting Powder", "price": 4200 },
  { "name": "MAC Mineralize Skinfinish", "price": 3600 },
  { "name": "Huda Beauty 3D Highlighter Palette", "price": 4200 },
  { "name": "Fenty Beauty Killawatt Freestyle", "price": 3200 },
  { "name": "Charlotte Tilbury Hollywood Glow", "price": 3900 },
  { "name": "Laura Mercier Face Illuminator", "price": 3700 },
  { "name": "Becca Shimmering Skin Perfector", "price": 3500 },
  { "name": "Anastasia Beverly Hills Glow Kit", "price": 4200 },
  { "name": "Kiko Milano Radiant Touch Cream Stick", "price": 1050 },
  { "name": "Sephora Collection Luminizer", "price": 1100 },
  { "name": "Too Faced Diamond Light Highlighter", "price": 3200 },
  { "name": "Benefit Cosmetics Watt’s Up!", "price": 2800 },
  { "name": "e.l.f. Baked Highlighter", "price": 450 },
  { "name": "Physicians Formula Butter Highlighter", "price": 850 },
  { "name": "Flower Beauty Shimmer & Strobe", "price": 950 },
  { "name": "Essence Pure Nude Highlighter", "price": 399 },
  { "name": "Catrice High Glow Mineral", "price": 499 },
  { "name": "Makeup Obsession Mega Lightning", "price": 650 },
  { "name": "Revolution Pro Supreme Highlighter", "price": 899 },
  { "name": "Typsy Beauty Silk Cushion Highlighter", "price": 1200 },
  { "name": "Praush Jelly Tint Highlighter", "price": 750 },
  { "name": "FAE Beauty Lush Liquid Highlighter", "price": 599 },
  { "name": "Daily Life Forever52 Highlighter", "price": 699 },
  { "name": "Mars Wonder Glow Highlighter", "price": 249 },
  { "name": "Plum Touch & Glow Highlighter", "price": 499 },
  { "name": "Bellavita Glow Highlighter", "price": 399 },
  { "name": "L.A. Girl Luminous Glow", "price": 850 },
  { "name": "Juvia’s Place Tribe Highlighter", "price": 1200 },
  { "name": "Rare Beauty Positive Light", "price": 3200 },
  { "name": "Ilia Liquid Light Serum Highlighter", "price": 3400 },
  { "name": "Glossier Haloscope Dew Effect", "price": 2800 },
  { "name": "Haus Labs Bio-Radiant Gel-Powder", "price": 3500 },
  { "name": "Tarte Amazonian Clay Highlighter", "price": 2900 },
  { "name": "Smashbox Halo Glow Highlighter", "price": 3100 },
  { "name": "Stila Heaven’s Hue Highlighter", "price": 2700 },
  { "name": "Urban Decay Naked Illuminated", "price": 3200 },
  { "name": "Cover FX Custom Enhancer Drops", "price": 3900 },
  { "name": "BareMinerals Endless Glow", "price": 2800 },
  { "name": "Clarins Glow 2 Go Duo", "price": 2500 },
  { "name": "Clinique Chubby Stick Sculpting", "price": 2400 },
  { "name": "Guerlain Terracotta Highlighter", "price": 4200 },
  { "name": "YSL Touche Éclat Shimmer Stick", "price": 4300 },
  { "name": "Lancome Dual Finish Highlighter", "price": 4100 },
  { "name": "Dior Backstage Glow Face Palette", "price": 4500 },
  { "name": "Chanel Baume Essentiel", "price": 4600 },
  { "name": "Tom Ford Sheer Highlighting Duo", "price": 5200 },
  { "name": "Pat McGrath Skin Fetish Highlighter", "price": 4800 },
  { "name": "Kevyn Aucoin The Neo Highlighter", "price": 3900 },
  { "name": "Hourglass Ambient Lighting Powder", "price": 4200 },
  { "name": "NARS Illuminator", "price": 3600 },
  { "name": "Burberry Fresh Glow", "price": 4100 },
  { "name": "Marc Jacobs Dew Drops", "price": 3700 },
  { "name": "Givenchy Teint Couture Shimmer", "price": 4400 },
  { "name": "Estee Lauder Bronze Goddess", "price": 4300 },
  { "name": "Shiseido Aura Dew", "price": 3900 },
  { "name": "Sisley Paris Phyto-Touche", "price": 5200 },
  { "name": "Rimmel London Insta Strobing", "price": 399 },
  { "name": "CoverGirl TruBlend Super Stunner", "price": 799 },

                  ],
                    "Cleansing & Hygiene": [
  
               { "name": "Dove Deep Moisture Body Wash", "price": 412 },
  { "name": "Fiama Gel Bar Patchouli & Macadamia", "price": 116 },
  { "name": "Palmolive Aroma Morning Boost Body Wash", "price": 295 },
  { "name": "Biotique Apricot Refreshing Body Wash", "price": 550 },
  { "name": "Nivea Frangipani & Oil Shower Gel", "price": 145 },
  { "name": "Himalaya Neem & Turmeric Soap", "price": 150 },
  { "name": "Pears Pure & Gentle Soap", "price": 349 },
  { "name": "Lux Velvet Touch Soap", "price": 305 },
  { "name": "Liril Cooling Mint Soap", "price": 177 },
  { "name": "Chandrika Ayurvedic Soap", "price": 135 },

  { "name": "Dettol Instant Hand Sanitizer", "price": 100 },
  { "name": "Savlon Hexa Advanced Sanitizer", "price": 211 },
  { "name": "Himalaya PureHands Sanitizer", "price": 50 },
  { "name": "Lifebuoy Total 10 Hand Sanitizer", "price": 120 },
  { "name": "Palmolive Antibacterial Hand Sanitizer", "price": 249 },
  { "name": "Dabur Herbal Hand Sanitizer", "price": 135 },
  { "name": "Godrej Protekt MasterBlaster", "price": 50 },
  { "name": "Zuci Instant Hand Sanitizer", "price": 100 },
  { "name": "Dr. Batra’s Non-Alcoholic Sanitizer", "price": 135 },
  { "name": "Sterillium Hand Disinfectant", "price": 429 },

  { "name": "Whisper Ultra Soft Sanitary Pads", "price": 350 },
  { "name": "Stayfree Secure XL Pads", "price": 275 },
  { "name": "Carmesi Biodegradable Pads", "price": 365 },
  { "name": "Nua Rash-Free Sanitary Pads", "price": 217 },
  { "name": "Sanfe Organic Cotton Pads", "price": 159 },
  { "name": "Avni Reusable Cloth Pads", "price": 399 },
  { "name": "Pee Safe Menstrual Cup", "price": 499 },
  { "name": "Sirona Reusable Menstrual Cup", "price": 499 },
  { "name": "The Woman’s Company Menstrual Cup", "price": 550 },
  { "name": "Fabpad Organic Sanitary Pads", "price": 349 },

  { "name": "VWash Plus Intimate Hygiene Wash", "price": 392 },
  { "name": "Lactacyd Feminine Hygiene Wash", "price": 319 },
  { "name": "Everteen Natural Intimate Wash", "price": 159 },
  { "name": "Sanfe Lavender & Chamomile Wash", "price": 175 },
  { "name": "I-Feel Gentle Intimate Wash", "price": 129 },
  { "name": "Avni Intimate Care Wash", "price": 199 },
  { "name": "Vagisil Scentsitive Scents Wash", "price": 1052 },
  { "name": "Summer’s Eve Daily Intimate Wash", "price": 835 },
  { "name": "Femfresh Sensitive Wash", "price": 2389 },
  { "name": "Freshie Natural Feminine Wash", "price": 4056 },

  { "name": "Colgate Total Toothpaste", "price": 201 },
  { "name": "Sensodyne Rapid Relief Toothpaste", "price": 216 },
  { "name": "Dabur Red Ayurvedic Toothpaste", "price": 249 },
  { "name": "Himalaya Complete Care Toothpaste", "price": 189 },
  { "name": "Pepsodent Germicheck Toothpaste", "price": 93 },
  { "name": "Closeup Ever Fresh Gel Toothpaste", "price": 98 },
  { "name": "Patanjali Dant Kanti Toothpaste", "price": 85 },
  { "name": "Glister Herbal Toothpaste", "price": 299 },
  { "name": "Perfora Teeth Whitening Toothpaste", "price": 249 },
  { "name": "Salt Natural Toothpaste", "price": 199 },

  { "name": "Listerine Cool Mint Mouthwash", "price": 370 },
  { "name": "Colgate Plax Fresh Mint Mouthwash", "price": 201 },
  { "name": "Himalaya Active Fresh Mouthwash", "price": 145 },
  { "name": "Dabur Meswak Mouthwash", "price": 216 },
  { "name": "Sensodyne Mouthwash", "price": 201 },
  { "name": "Perfora Oral Rinse", "price": 249 },
  { "name": "Salt Mouth Detox", "price": 199 },
  { "name": "Oral-B Fresh Mint Mouthwash", "price": 399 },
  { "name": "Sirona Herbal Mouthwash", "price": 249 },
  { "name": "Dr. Batra’s Herbal Mouthwash", "price": 200 },

  { "name": "Oral-B Crisscross Toothbrush", "price": 190 },
  { "name": "Colgate ZigZag Toothbrush", "price": 101 },
  { "name": "Sensodyne Sensitive Toothbrush", "price": 111 },
  { "name": "Perfora Electric Toothbrush", "price": 1599 },
  { "name": "Salt Biodegradable Toothbrush", "price": 249 },
  { "name": "Seven Oral Care SuperBrush", "price": 1999 },
  { "name": "POLR Smart Brush", "price": 1499 },
  { "name": "Agaro Sonic Toothbrush", "price": 1463 },
  { "name": "Oral-B Vitality Electric Toothbrush", "price": 1529 },
  { "name": "Mee Mee Kids Toothbrush", "price": 156 },

  { "name": "Oral-B Essential Dental Floss", "price": 249 },
  { "name": "Colgate Total Dental Floss", "price": 244 },
  { "name": "Listerine Gentle Gum Floss", "price": 299 },
  { "name": "Perfora Mint Flavored Floss", "price": 239 },
  { "name": "Salt Eco Dental Floss", "price": 199 },


  { "name": "Cetaphil Cleansing & Moisturising Syndet Bar", "price": 189 },
  { "name": "Yardley London English Lavender Luxury Soap", "price": 184 },
  { "name": "Sadguru Gramflour Ayurvedic Soap", "price": 239 },
  { "name": "Fiama Blackcurrant & Bearberry Gel Bar", "price": 416 },
  { "name": "Lux Soft Glow Rose & Vitamin E Soap", "price": 305 },
  { "name": "Kingvaliy Kojic Whitening Soap", "price": 150 },
  { "name": "Richfeel Calendula Anti-Acne Soap", "price": 167 },
  { "name": "Reen Naturals ABC Luxury Soap", "price": 274 },
  { "name": "Pears Soft & Fresh Mint Soap", "price": 266 },
  { "name": "Vivel Glycerin Bathing Bar with Almond Oil", "price": 140 },

  { "name": "Dove Serum Bar with Sandalwood Oil", "price": 215 },
  { "name": "Liril Lime & Tea Tree Oil Soap", "price": 209 },
  { "name": "Lux Velvet Glow Jasmine Soap", "price": 305 },
  { "name": "Glutalight Brightening Soap", "price": 274 },
  { "name": "Dermatouch Kojic Acid Soap with Glutathione", "price": 137 },
  { "name": "Fiama Japanese Hokkaido Milk Soap", "price": 536 },
  { "name": "Agonize Kojic Whitening Soap", "price": 228 },
  { "name": "ZENISK Skinshine Fairness Soap", "price": 252 },
  { "name": "Coollest Tan Removal Whitening Soap", "price": 73 },
  { "name": "Bussi Saffron & Sandal Soap", "price": 150 },

  { "name": "Healthy Hands Hand Sanitizer 500ml", "price": 199 },
  { "name": "Apollo Life Mist Spray Sanitizer 500ml", "price": 225 },
  { "name": "Germ-X Moisturizing Gel Sanitizer 32oz", "price": 7422 },
  { "name": "Delta Germ Alcohol-Based Sanitizer 2oz x48", "price": 10878 },
  { "name": "Justhuman 24hr Protection Spray 10ml x4", "price": 315 },
  { "name": "BJAIN Omeo Aloe Vera Sanitizer 1L", "price": 333 },
  { "name": "Inatur Lemon & Aloe Sanitizer Gel 500ml", "price": 200 },
  { "name": "Maxisoft Cherry Blossom Spray 120ml x4", "price": 249 },
  { "name": "Sharp Palm Cleanser Sachets x200", "price": 155 },
  { "name": "QUARANT WHO Formula Sanitizer 5L", "price": 1199 },

  { "name": "Savlon Professional Refill Can 5L", "price": 1499 },
  { "name": "Hi Life Viro Care Alcohol-Free Sanitizer", "price": 261 },
  { "name": "Omeo Aloe Vera Gel Sanitizer 5L", "price": 999 },
  { "name": "K'TRiQ WHO Formula Sanitizer 5L", "price": 1099 },
  { "name": "DEE India Medisafe Alcohol Sanitizer 100ml x3", "price": 135 },
  { "name": "Purest Advanced Blue Liquid Sanitizer 5L", "price": 799 },
  { "name": "Vyom Herbal Mint Spray Sanitizer", "price": 249 },
  { "name": "Elem Lavender & Lime Spray 100ml x3", "price": 212 },
  { "name": "Trycone WHO Formula Sanitizer 5L", "price": 1599 },
  { "name": "SterloMax Ethanol-Based Sanitizer 500ml x2", "price": 429 },

  { "name": "Vagisil Peach Blossom Feminine Wash", "price": 1052 },
  { "name": "Freshie Natural Feminine Care Wash 8oz", "price": 4056 },
  { "name": "Femfresh Sensitive Cleansing Bundle", "price": 2389 },
  { "name": "Scentsitive Citrus Paradise Wipes x20", "price": 835 },
  { "name": "Lotus Extract pH Balanced Intimate Wash", "price": 237 },
  { "name": "Rustic Art Organic Intimate Wash for Men", "price": 270 },
  { "name": "Feminelle Refreshing Intimate Wash 300ml", "price": 308 },
  { "name": "Avni Natural Cotton Sanitary Pads", "price": 349 },
  { "name": "Sanfe Reusable Banana Fiber Pads", "price": 399 },
  { "name": "Sirona Menstrual Cup Wash", "price": 249 },

  { "name": "Carmesi Biodegradable Tampons", "price": 299 },
  { "name": "Nua Rash-Free Sanitary Pads", "price": 217 },
  { "name": "Pee Safe Menstrual Cup", "price": 499 },
  { "name": "The Woman’s Company Menstrual Cup", "price": 550 },
  { "name": "VWash Expert Intimate Hygiene 200ml", "price": 392 },
  { "name": "Lactacyd Feminine Hygiene Wash", "price": 319 },
  { "name": "Everteen Natural Intimate Wash", "price": 159 },
  { "name": "Sanfe Lavender & Chamomile Wash", "price": 175 },
  { "name": "I-Feel Gentle Intimate Wash", "price": 129 },
  { "name": "Avni Intimate Care Wash", "price": 199 },

  { "name": "Colgate Herbal Toothpaste 200g", "price": 165 },
  { "name": "Oralvit Baking Soda Toothpaste & Mouthwash", "price": 600 },
  { "name": "Oral-B Crisscross Gum Care Toothbrush x4", "price": 190 },
  { "name": "Starki Teens Gum Strengthening Toothpaste", "price": 399 },
  { "name": "Mamaearth Orange Kids Toothpaste 50g", "price": 149 },
  { "name": "Perfora Teeth Whitening Toothpaste", "price": 249 },
  { "name": "Dabur Meswak Herbal Toothpaste", "price": 249 },
  { "name": "Sensodyne Rapid Relief Toothpaste", "price": 216 },
  { "name": "Listerine Cool Mint Mouthwash", "price": 370 },
  { "name": "Oral-B Essential Dental Floss", "price": 249 },



  { "name": "Dr. Bronner's Peppermint Castile Bar Soap", "price": 671 },
  { "name": "Mcaffeine Rainforest Rinse Shower Jelly Soap", "price": 399 },
  { "name": "Mcaffeine Berry Squeeze Shower Jelly Soap", "price": 399 },
  { "name": "Mcaffeine Blueberry Bounce Shower Jelly Soap", "price": 399 },
  { "name": "ST. D'VENCE Tea Tree Body Wash", "price": 799 },
  { "name": "Man Matters Charcoal & Menthol Body Wash", "price": 217 },
  { "name": "BAKE Kojic Acid Brightening Body Wash", "price": 299 },
  { "name": "Arata Salicylic Acid Body Wash", "price": 249 },
  { "name": "Be Bodywise Hyaluronic Acid Body Wash Mousse", "price": 379 },
  { "name": "ST. D'VENCE Ocean Drop Salicylic Acid Body Wash", "price": 499 },

  { "name": "DABUR Skinetics Foam Body Wash", "price": 399 },
  { "name": "Skin Harmony AHA & BHA Body Wash", "price": 299 },
  { "name": "St. D’vence Breezy Brew Body Wash", "price": 799 },
  { "name": "Khadi Omorose Neem & Tulsi Body Wash", "price": 175 },
  { "name": "St. D’vence Summer Blend Body Wash", "price": 399 },
  { "name": "ST. D'VENCE Himalayan Pink Salt Body Wash", "price": 799 },
  { "name": "St. D’vence Bliss Berry Body Wash", "price": 399 },
  { "name": "Menworks Ambre Noir Bodywash", "price": 499 },
  { "name": "ST. D'VENCE Postcard Collection Body Wash Combo", "price": 1299 },
  { "name": "Schülke Octenisan Body Wash Lotion", "price": 550 },

  { "name": "St. D’vence Berry Bunch Body Wash", "price": 799 },
  { "name": "ArmourMe Waterless Body Wash Foam", "price": 449 },
  { "name": "Bad Lab Caveman Cleaner 3-in-1", "price": 549 },
  { "name": "NIVEA Men Energy Shower Gel", "price": 192 },
  { "name": "Kaved Essentials Mango Shower Gel", "price": 249 },
  { "name": "Sairo Strawberry Bath Gel (Imported)", "price": 599 },
  { "name": "Skin-Fay Ceramide Body Wash", "price": 599 },
  { "name": "BROER Ice Burst Cooling Body Wash", "price": 299 },
  { "name": "Nidos AF Body Wash", "price": 428 },
  { "name": "New Aquaderm Face & Body Wash", "price": 460 },

  { "name": "ProRange HERBOLIFE Lemon Shower Gel", "price": 550 },
  { "name": "ST. D'VENCE Bliss Berry Shower Gel", "price": 399 },
  { "name": "ST. D'VENCE Summer Blend Shower Gel", "price": 399 },
  { "name": "ST. D'VENCE Himalayan Pink Salt Shower Gel", "price": 799 },
  { "name": "ST. D'VENCE Breezy Brew Shower Gel", "price": 799 },
  { "name": "ST. D'VENCE Postcard Collection Shower Gel Combo", "price": 1299 },
  { "name": "ST. D'VENCE Berry Bunch Shower Gel", "price": 799 },
  { "name": "ST. D'VENCE Refreshing Ocean Drop Shower Gel", "price": 499 },
  { "name": "ST. D'VENCE The Postcard Collection Shower Gel", "price": 1299 },
  { "name": "ST. D'VENCE Tan Removal Shower Gel", "price": 499 },

  { "name": "Oralvit Baking Soda Toothpaste & Mouthwash Combo", "price": 600 },
  { "name": "Colgate Herbal Toothpaste", "price": 165 },
  { "name": "Dentaids Sentim Desensitizing Toothpaste", "price": 891 },
  { "name": "STARKI Teens Gum Strengthening Toothpaste", "price": 399 },
  { "name": "Oral-B Crisscross Gum Care Toothbrush Pack", "price": 190 },
  { "name": "Oral-B Essential Dental Floss", "price": 249 },
  { "name": "Listerine Gentle Gum Floss", "price": 299 },
  { "name": "Perfora Mint Flavored Floss", "price": 239 },
  { "name": "Salt Eco Dental Floss", "price": 199 },
  { "name": "Oral-B Vitality Electric Toothbrush", "price": 1529 },

  { "name": "POLR Smart Toothbrush", "price": 1499 },
  { "name": "Seven Oral Care SuperBrush", "price": 1999 },
  { "name": "Perfora Electric Toothbrush", "price": 1599 },
  { "name": "Salt Biodegradable Toothbrush", "price": 249 },
  { "name": "Agaro Sonic Toothbrush", "price": 1463 },
  { "name": "Oral-B Fresh Mint Mouthwash", "price": 399 },
  { "name": "Sirona Herbal Mouthwash", "price": 249 },
  { "name": "Dr. Batra’s Herbal Mouthwash", "price": 200 },
  { "name": "Perfora Oral Rinse", "price": 249 },
  { "name": "Salt Mouth Detox", "price": 199 },

  { "name": "Vagisil Peach Blossom Feminine Wash", "price": 1052 },
  { "name": "Freshie Natural Feminine Care Wash", "price": 4056 },
  { "name": "Femfresh Sensitive Cleansing Bundle", "price": 2389 },
  { "name": "Scentsitive Citrus Paradise Wipes", "price": 835 },
  { "name": "Lotus Extract pH Balanced Intimate Wash", "price": 237 },
  { "name": "Rustic Art Organic Intimate Wash for Men", "price": 270 },
  { "name": "Feminelle Refreshing Intimate Wash", "price": 308 },
  { "name": "Avni Natural Cotton Sanitary Pads", "price": 349 },
  { "name": "Sanfe Reusable Banana Fiber Pads", "price": 399 },
  { "name": "Sirona Menstrual Cup Wash", "price": 249 },

                  ],
                    "Frangance": [
  
               { "name": "Creed Aventus Eau De Parfum For Men, 3.3 Oz", "price": 48605 },
  { "name": "Versace Eros EDT Spray For Men - 6.7 Oz", "price": 9973 },
  { "name": "Carolina Herrera Eau De Perfume Spray 100Ml", "price": 10806 },
  { "name": "Creed Aventus Cologne Eau De Parfum Men 50 Ml", "price": 53907 },
  { "name": "Generic D.Sauvage For Men Eau De Parfum Spray 60 Ml", "price": 9750 },
  { "name": "KELYN Ocean Breeze Body Mist Spray - 200Ml", "price": 399 },
  { "name": "Forest Essentials Oudh & Green Tea Body Mist - 50Ml", "price": 1350 },
  { "name": "Forest Essentials Nargis Body Mist - 50Ml", "price": 1350 },
  { "name": "Fabessentials Oceans Bliss Body Mist - 150Ml", "price": 445 },
  { "name": "SO Fresh Floral Body Mist Spray - 100Ml", "price": 299 },
  { "name": "United Colors Of Benetton Tribe Intense Deodorant Spray - 150Ml", "price": 745 },
  { "name": "Dove Invisible Solid Antiperspirant Stick For Women (Pack of 6)", "price": 3749 },
  { "name": "Dove Men+Care Sensitive Shield Antiperspirant - 2.7 Oz", "price": 1870 },
  { "name": "Ban Invisible Solid Antiperspirant (Pack of 4)", "price": 2217 },
  { "name": "Dove Original Clean Antiperspirant Stick (Pack of 6)", "price": 3319 },
  { "name": "Layer'r Wottagirl Vanilla Twist Body Mist - 135ml", "price": 186 },
  { "name": "Plum BodyLovin' Vanilla Vibes Body Mist - 150ml", "price": 389 },
  { "name": "Bella Vita Senorita Body Mist - 150ml", "price": 282 },
  { "name": "Aqualogica Sweet Summer Kiss Body Mist - 150ml", "price": 373 },
  { "name": "Bath & Body Works Into The Night Body Mist - 75ml", "price": 749 },
  { "name": "Victoria's Secret Bare Vanilla Fragrance Mist", "price": 2499 },
  { "name": "Victoria's Secret Love Spell Fragrance Mist", "price": 2499 },
  { "name": "Victoria's Secret Velvet Petals Fragrance Mist", "price": 2499 },
  { "name": "Victoria's Secret Pure Seduction Fragrance Mist", "price": 2499 },
  { "name": "Victoria's Secret Aqua Kiss Fragrance Mist", "price": 2499 },
  { "name": "Nivea Men Fresh Active Deodorant Spray - 150ml", "price": 142 },
  { "name": "Kamasutra Spark Deodorant Body Spray - 220ml", "price": 185 },
  { "name": "Denver Hamilton Deodorant Body Spray - 165ml", "price": 239 },
  { "name": "Set Wet Cool Avatar Deodorant Spray - 150ml", "price": 132 },
  { "name": "Engage Floral Zest Body Spray - 150ml", "price": 140 },
  { "name": "Beardo Iceman Perfume Deo Spray - 150ml", "price": 174 },
  { "name": "Park Avenue Voyage Perfume Spray - 100ml", "price": 225 },
  { "name": "Fogg Marco Fragrance Body Spray - 150ml", "price": 247 },
  { "name": "Jovan White Musk Body Spray - 200ml", "price": 199 },
  { "name": "Axe Dark Temptation Bodyspray - 150ml", "price": 232 },
  { "name": "Park Avenue Discover Body Spray - 150ml", "price": 225 },
  { "name": "Sweatnil Anti-Perspirant Gel - 50ml", "price": 171 },
  { "name": "Yardley London Morning Dew Body Spray - 150ml", "price": 139 },
  { "name": "Nivea Pearl & Beauty Deodorant Spray - 150ml", "price": 270 },
  { "name": "Secret Temptation Romance Body Deodorant - 150ml", "price": 193 },
  { "name": "Be Bodywise Underarm Roll On - 50ml", "price": 329 },
  { "name": "Rexona Powder Dry Roll On - 50ml", "price": 182 },
  { "name": "Carmesi Floral Sunset Roll On - 50ml", "price": 175 },
  { "name": "Envy Blush Perfume Deodorant Spray - 140ml", "price": 178 },
  { "name": "Fogg Essence No Gas Body Spray - 150ml", "price": 191 },
  { "name": "Wild Stone Ultra Sensual Body Spray - 150ml", "price": 298 },
  { "name": "Park Avenue Good Morning Body Spray - 150ml", "price": 295 },
  { "name": "Ajmal Evoke Silver Edition Deodorant - 150ml", "price": 171 },
  { "name": "French Essence No Gas Parfum Body Spray - 150ml", "price": 157 },


  { "name": "BEARDO Men Origin Eau De Parfum - 100ml", "price": 1200 },
  { "name": "Park Avenue Knight Eau De Parfum - 100ml", "price": 499 },
  { "name": "Wild Stone Edge Eau De Parfum - 100ml", "price": 314 },
  { "name": "Bella Vita CEO Man Eau De Parfum - 100ml", "price": 528 },
  { "name": "Djokr Signature Eau De Parfum - 100ml", "price": 298 },
  { "name": "Park Avenue Euphoria Eau De Parfum - 100ml", "price": 335 },
  { "name": "Beardo Whisky Smoke Eau De Parfum - 50ml", "price": 370 },
  { "name": "Bella Vita Honey Oud Eau De Parfum - 20ml", "price": 199 },
  { "name": "Wild Stone Hydra Energy Eau De Parfum - 100ml", "price": 324 },
  { "name": "Park Avenue Regal No Gas Perfume - 130ml", "price": 134 },
  { "name": "Victoria's Secret Midnight Bloom Fragrance Mist", "price": 2499 },
  { "name": "Victoria's Secret Amber Romance Fragrance Mist", "price": 2499 },
  { "name": "Victoria's Secret Rush Fragrance Mist", "price": 2499 },
  { "name": "Victoria's Secret Temptation Fragrance Mist", "price": 2499 },
  { "name": "Victoria's Secret Romantic Fragrance Mist", "price": 2499 },
  { "name": "Bath & Body Works Dark Kiss Body Mist - 75ml", "price": 749 },
  { "name": "Plum BodyLovin' Hawaiian Rumba Body Mist - 150ml", "price": 389 },
  { "name": "Layer'r Wottagirl Secret Crush Body Mist - 135ml", "price": 189 },
  { "name": "Aqualogica Sun Kissed Vanilla Body Mist - 150ml", "price": 373 },
  { "name": "Bella Vita Date Woman Body Mist - 150ml", "price": 305 },
  { "name": "Yardley London Violet & Raspberry Mist - 135ml", "price": 209 },
  { "name": "Nike Trendy Pink Woman Body Mist - 200ml", "price": 330 },
  { "name": "PureSense Cherry Blossom Body Mist - 150ml", "price": 220 },
  { "name": "AND Dainty Glam Body Mist - 200ml", "price": 179 },
  { "name": "La Pink Wild Secret Body Mist - 200ml", "price": 279 },
  { "name": "Be Bodywise Vanilla Vibes Underarm Roll On - 50ml", "price": 243 },
  { "name": "Nivea Pearl & Beauty Roll On - 50ml", "price": 149 },
  { "name": "Rexona Shower Fresh Roll On - 50ml", "price": 95 },
  { "name": "Carmesi Floral Sunset Roll On - 50ml", "price": 170 },
  { "name": "Secret Temptation Romance Deodorant Spray - 150ml", "price": 157 },
  { "name": "Engage Floral Zest Deodorant Spray - 150ml", "price": 167 },
  { "name": "Yardley London Morning Dew Spray - 150ml", "price": 139 },
  { "name": "Spinz Enchante Perfumed Deo Spray - 200ml", "price": 206 },
  { "name": "Nivea Fresh Natural Deodorant Spray - 150ml", "price": 147 },
  { "name": "Fogg Paradise Body Spray - 150ml", "price": 191 },
  { "name": "Denver Hamilton Deodorant Spray - 165ml", "price": 239 },
  { "name": "Set Wet Charm Avatar Deodorant Spray - 150ml", "price": 132 },
  { "name": "Beardo Maverick Perfume Deo Spray - 150ml", "price": 174 },
  { "name": "Park Avenue Neo Body Spray - 220ml", "price": 261 },
  { "name": "Sweatnil Anti-Perspirant Gel - 50ml", "price": 171 },
  { "name": "Jovan Musk Body Spray - 200ml", "price": 199 },
  { "name": "Axe Dark Temptation Body Spray - 150ml", "price": 232 },
  { "name": "Kamasutra Spark Power Series Spray - 135ml", "price": 199 },
  { "name": "French Essence Jazz No Gas Spray - 150ml", "price": 178 },
  { "name": "Ajmal Evoke Silver Edition Deo Spray - 150ml", "price": 171 },
  { "name": "The Man Company Blanc Body Perfume - 120ml", "price": 399 },
  { "name": "Bella Vita White Oud Body Deo Spray - 150ml", "price": 175 },
  { "name": "La French Luxure Oudh Body Spray - 150ml", "price": 143 },
  { "name": "Skinn By Titan Raw Deodorant Spray - 150ml", "price": 535 },

  { "name": "Davidoff Cool Water Eau De Toilette - 125ml", "price": 1200 },
  { "name": "Jaguar Classic Black Eau De Toilette - 100ml", "price": 1399 },
  { "name": "Armaf Club De Nuit Intense Man EDT - 105ml", "price": 1495 },
  { "name": "Skinn By Titan Verge Eau De Parfum - 100ml", "price": 1799 },
  { "name": "Fastrack Trance Eau De Parfum - 100ml", "price": 676 },
  { "name": "Ustraa Tattoo Cologne - 100ml", "price": 404 },
  { "name": "Bombay Shaving Company Mexico Perfume - 100ml", "price": 333 },
  { "name": "Minara Luxury Woman Eau De Parfum Gift Set - 2x25ml", "price": 169 },
  { "name": "Envy Natural Spray Perfume - 100ml", "price": 96 },
  { "name": "Oscar Forever Scents For Her - 8ml x 11", "price": 293 },
  { "name": "Villain Hydra Eau De Parfum - 100ml", "price": 352 },
  { "name": "Wildplay Chocolate Spray Perfume - 100ml", "price": 247 },
  { "name": "OG Beauty Enchant Eau De Parfum - 100ml", "price": 184 },
  { "name": "Kingvaliy Dunhill London Icon Absolute Eau De Cologne - 100ml", "price": 277 },
  { "name": "La French Luxure Oudh Perfume - 100ml", "price": 549 },
  { "name": "Oscar Forever Luxury Combo Aqua & Oud - 100ml x 2", "price": 268 },
  { "name": "Bella Vita Luxury Senorita Eau De Parfum - 100ml", "price": 499 },
  { "name": "Mamaearth Into the Sunset Eau De Parfum - 100ml", "price": 719 },
  { "name": "Plum BodyLovin' Orchid-You-Not Perfume - 15ml", "price": 251 },
  { "name": "Insight Cosmetics Cherry Eau De Perfume - 50ml", "price": 190 },
  { "name": "Just Herbs Floral Fiesta Body Spray - 150ml", "price": 163 },
  { "name": "Bryan & Candy Tropical Fling Body Mist - 150ml", "price": 199 },
  { "name": "FOGG Ossum Blossom Body Mist - 115ml", "price": 199 },
  { "name": "FOGG Ossum Delight Body Mist - 115ml", "price": 211 },
  { "name": "AND Chi Connect Body Mist - 200ml", "price": 200 },
  { "name": "Wottagirl Cupid Heart Body Splash - 100ml", "price": 189 },
  { "name": "Nike Sea Breeze Body Mist - 200ml", "price": 349 },
  { "name": "Yardley London Violet & Raspberry Mist - 135ml", "price": 209 },
  { "name": "The Body Shop Shea Body Mist - 100ml", "price": 895 },
  { "name": "PureSense Hope Japanese Cherry Blossom Mist - 150ml", "price": 220 },
  { "name": "Plum BodyLovin' Smokin' Vanilla Mist - 150ml", "price": 445 },
  { "name": "La Pink Dream Romance Mist - 50ml", "price": 127 },
  { "name": "La Pink Pure Love Mist - 50ml", "price": 127 },
  { "name": "FOGG Paradise Body Spray - 150ml", "price": 153 },
  { "name": "Plum BodyLovin' Vanilla Vibes Roll On - 50ml", "price": 243 },
  { "name": "Be Bodywise 6% AHA BHA Roll On - 50ml", "price": 329 },
  { "name": "NIVEA Natural Glow Roll On - 50ml", "price": 141 },
  { "name": "Rexona Shower Fresh Roll On - 50ml", "price": 95 },
  { "name": "Carmesi Natural Roll On - 50ml", "price": 170 },
  { "name": "Yardley London English Lavender Roll On - 50ml", "price": 149 },
  { "name": "Dr. Organic Tea Tree Roll On - 50ml", "price": 524 },
  { "name": "Cos-IQ Brightening Roll On Serum - 40ml", "price": 482 },
  { "name": "Secret Temptation Travel Pack Mini Deos - 50ml x 4", "price": 277 },
  { "name": "Envy Blush Perfume Deo Spray - 140ml", "price": 178 },
  { "name": "Fogg 1000 Sprays Essence Body Spray - 150ml", "price": 160 },
  { "name": "Layer'r Wottagirl Mystic Island Body Mist - 135ml", "price": 186 },
  { "name": "Spinz Enchante Perfumed Deo Spray - 200ml", "price": 206 },
  { "name": "Yardley London Alpine Rose Mist - 135ml", "price": 167 },
  { "name": "Nike Trendy Pink Woman Mist - 200ml", "price": 330 },
  { "name": "Plum BodyLovin' Trippin' Mimosas Mist - 150ml", "price": 403 },
  { "name": "Bella Vita Date Woman Mist - 150ml", "price": 305 },
  { "name": "Aqualogica Mid Night Bloom Mist - 150ml", "price": 423 },
  { "name": "Aqualogica Cherry Blossom Bloom Mist - 150ml", "price": 423 },
  { "name": "Aqualogica Sweet Summer Kiss Mist - 150ml", "price": 423 },
  { "name": "Aqualogica Dewy Floral Kiss Mist - 150ml", "price": 373 },
  { "name": "Aqualogica Ocean Breeze Mist - 150ml", "price": 373 },
  { "name": "FOGG Ossum Fresh Fougere Mist - 150ml", "price": 222 },
  { "name": "FOGG Marco Body Spray - 175ml", "price": 191 },
  { "name": "FOGG Royal Body Spray - 175ml", "price": 191 },
  { "name": "FOGG Napoleon Body Spray - 175ml", "price": 191 },
  { "name": "FOGG Essence No Gas Spray - 150ml", "price": 191 },
  { "name": "FOGG Fresh Oriental Spray - 120ml", "price": 220 },
  { "name": "FOGG Fresh Fougere Spray - 150ml", "price": 222 },
  { "name": "FOGG Status Roll On - 50ml", "price": 161 },
  { "name": "Park Avenue Voyage Corsica Cool Spray - 120ml", "price": 314 },
  { "name": "Park Avenue Voyage Amazon Woods Spray - 120ml", "price": 300 },
  { "name": "Park Avenue Conquer Eau De Parfum - 100ml", "price": 399 },
  { "name": "Park Avenue Knight Eau De Parfum - 100ml", "price": 499 },
  { "name": "Park Avenue Good Morning Grooming Kit", "price": 625 },
  { "name": "Park Avenue Luxury Grooming Kit 8-In-1", "price": 899 },
  { "name": "Park Avenue Regal No Gas Perfume - 130ml", "price": 134 },
  { "name": "Park Avenue Voyage Savanna Fresh Perfume - 120ml", "price": 314 },
  { "name": "Park Avenue Discover Body Spray - 150ml", "price": 225 },
  { "name": "Park Avenue Neo Body Spray - 220ml", "price": 261 },
  { "name": "Park Avenue Good Morning Body Spray - 150ml", "price": 295 },

  { "name": "Armaf Le Parfait Pour Homme Eau De Parfum - 100ml", "price": 1399 },
  { "name": "Jaguar Classic Gold Eau De Toilette - 100ml", "price": 1495 },
  { "name": "Ustraa Base Camp Cologne - 100ml", "price": 404 },
  { "name": "Fastrack Pulse Eau De Parfum - 100ml", "price": 676 },
  { "name": "Bombay Shaving Company Tokyo Perfume - 100ml", "price": 333 },
  { "name": "Minara Luxury Man Eau De Parfum Gift Set - 2x25ml", "price": 169 },
  { "name": "Envy Magnetic Natural Spray Perfume - 100ml", "price": 96 },
  { "name": "Oscar Forever Scents For Him - 8ml x 11", "price": 293 },
  { "name": "Villain Desire Eau De Parfum - 100ml", "price": 352 },
  { "name": "OG Beauty Enchant Eau De Parfum - 100ml", "price": 184 },
  { "name": "Kingvaliy Dunhill London Icon Absolute Eau De Cologne - 100ml", "price": 277 },
  { "name": "La French Luxure Oudh Perfume - 100ml", "price": 549 },
  { "name": "Mamaearth ME Eau De Parfum - 100ml", "price": 719 },
  { "name": "Plum BodyLovin' Orchid-You-Not Perfume - 15ml", "price": 251 },
  { "name": "Insight Cosmetics Vanilla Eau De Perfume - 50ml", "price": 190 },
  { "name": "Just Herbs Vanilla Spice Body Spray - 150ml", "price": 163 },
  { "name": "Bryan & Candy Vanilla Vibe Body Mist - 150ml", "price": 199 },
  { "name": "FOGG Ossum Pleasure Body Mist - 115ml", "price": 199 },
  { "name": "FOGG Ossum Romance Body Mist - 115ml", "price": 211 },
  { "name": "AND Pretty Vogue Body Mist - 200ml", "price": 200 },
  { "name": "Wottagirl Tuscan Green Body Splash - 100ml", "price": 189 },
  { "name": "Nike Purple Body Mist - 200ml", "price": 349 },
  { "name": "The Body Shop Vanilla Body Mist - 100ml", "price": 895 },
  { "name": "PureSense Hope Japanese Cherry Blossom Mist - 150ml", "price": 220 },
  { "name": "Plum BodyLovin' Smokin' Vanilla Mist - 150ml", "price": 445 },
  { "name": "La Pink Mini Mist Gift Set - 4x50ml", "price": 331 },
  { "name": "La Pink Wild Secret Mist - 50ml", "price": 127 },
  { "name": "FOGG Paradise Body Spray - 150ml", "price": 153 },
  { "name": "Plum BodyLovin' Orchid-You-Not Roll On - 50ml", "price": 243 },
  { "name": "Be Bodywise 4% AHA BHA Roll On - 50ml", "price": 329 },
  { "name": "NIVEA Natural Glow Roll On - 50ml", "price": 141 },
  { "name": "Rexona Powder Dry Roll On - 50ml", "price": 95 },
  { "name": "Carmesi Natural Roll On - 50ml", "price": 170 },
  { "name": "Yardley London English Rose Roll On - 50ml", "price": 149 },
  { "name": "Dr. Organic Aloe Vera Roll On - 50ml", "price": 524 },
  { "name": "Cos-IQ Brightening Roll On Serum - 40ml", "price": 482 },
  { "name": "Secret Temptation Mini Deos Travel Pack - 50ml x 4", "price": 277 },
  { "name": "Envy Blush Perfume Deo Spray - 140ml", "price": 178 },
  { "name": "Fogg 1000 Sprays Paradise Body Spray - 150ml", "price": 160 },
  { "name": "Layer'r Wottagirl Amber Kiss Body Mist - 135ml", "price": 186 },
  { "name": "Spinz Enchante Perfumed Deo Spray - 200ml", "price": 206 },
  { "name": "Yardley London Alpine Rose Mist - 135ml", "price": 167 },
  { "name": "Nike Purple Woman Mist - 200ml", "price": 330 },
  { "name": "Plum BodyLovin' Trippin' Mimosas Mist - 150ml", "price": 403 },
  { "name": "Bella Vita Date Woman Mist - 150ml", "price": 305 },
  { "name": "Aqualogica Mid Night Bloom Mist - 150ml", "price": 423 },
  { "name": "Aqualogica Cherry Blossom Bloom Mist - 150ml", "price": 423 },
  { "name": "Aqualogica Sweet Summer Kiss Mist - 150ml", "price": 423 },
  { "name": "Aqualogica Dewy Floral Kiss Mist - 150ml", "price": 373 },
  { "name": "Aqualogica Ocean Breeze Mist - 150ml", "price": 373 },
  { "name": "FOGG Ossum Fresh Fougere Mist - 150ml", "price": 222 },
  { "name": "FOGG Marco Body Spray - 175ml", "price": 191 },
  { "name": "FOGG Royal Body Spray - 175ml", "price": 191 },
  { "name": "FOGG Napoleon Body Spray - 175ml", "price": 191 },
  { "name": "FOGG Fresh Oriental Spray - 120ml", "price": 220 },
  { "name": "FOGG Fresh Fougere Spray - 150ml", "price": 222 },
  { "name": "FOGG Status Roll On - 50ml", "price": 161 },
  { "name": "Park Avenue Voyage Obsession Spray - 120ml", "price": 314 },
  { "name": "Park Avenue Voyage Amazon Woods Spray - 120ml", "price": 300 },
  { "name": "Park Avenue Conquer Eau De Parfum - 100ml", "price": 399 },
  { "name": "Park Avenue Knight Eau De Parfum - 100ml", "price": 499 },
  { "name": "Park Avenue Good Morning Grooming Kit", "price": 625 },
  { "name": "Park Avenue Luxury Grooming Kit 8-In-1", "price": 899 },
  { "name": "Park Avenue Regal No Gas Perfume - 130ml", "price": 134 },
  { "name": "Park Avenue Voyage Savanna Fresh Perfume - 120ml", "price": 314 },
  { "name": "Park Avenue Discover Body Spray - 150ml", "price": 225 },
  { "name": "Park Avenue Neo Body Spray - 220ml", "price": 261 },
  { "name": "Park Avenue Good Morning Body Spray - 150ml", "price": 295 },
  { "name": "Ajmal Evoke Gold Edition Deodorant - 150ml", "price": 171 },
  { "name": "French Essence Wild No Gas Parfum Spray - 150ml", "price": 157 },
  { "name": "Skinn By Titan Escapade Mediterranean Grove Deo Spray - 150ml", "price": 535 },

                  ],
                    "Nail & Cuticle Care": [
    { "name": "Lakmé Nail Color Remover with Vitamin E - 27ml", "price": 61 },
  { "name": "Colorbar Acetone-Free Nail Polish Remover - 110ml", "price": 129 },
  { "name": "Blue Heaven Dip & Twist Nail Polish Remover - 40ml", "price": 71 },
  { "name": "RENÉE Nail Paint Remover Wipes - 50 Wipes", "price": 79 },
  { "name": "Faces Canada InstaRemove Dip & Twist Remover - 80ml", "price": 125 },
  { "name": "Plum Color Affair Acetone-Free Nail Polish Remover - 30ml", "price": 98 },
  { "name": "Swiss Beauty Nail Polish Remover Wipes - 32 Wipes", "price": 56 },
  { "name": "Just Herbs Acetone-Free Nail Paint Remover - 30ml", "price": 108 },
  { "name": "DeBelle Nail Polish Remover Wipes - Blueberry Blush - 30 Pads", "price": 162 },
  { "name": "Colorbar Ultimate Nail Enamel Remover - Dark Chocolate - 80ml", "price": 182 },
  { "name": "Dazller Nail Polish Remover Wipes - Pack of 3", "price": 196 },
  { "name": "Elle 18 Nail Paint Remover - 27ml", "price": 69 },
  { "name": "Flicka Neat & Clean Nail Polish Remover - 300ml", "price": 79 },
  { "name": "LeeBso Acetone-Free Nail Paint Remover - 30ml", "price": 259 },
  { "name": "Mianyang Magic Gel Nail Polish Remover - 15ml", "price": 1768 },
  { "name": "Colorbar On-the-Go Nail Lacquer Remover Wipes - 30 Pieces", "price": 129 },
  { "name": "Blue Heaven Gentle Nail Paint Remover - 125ml", "price": 91 },
  { "name": "Inatur Nail Paint Remover Wipes - 50 Wipes", "price": 108 },
  { "name": "Faces Canada Nail Enamel Remover - 90ml", "price": 119 },
  { "name": "Swiss Beauty Nail Polish Remover with Jojoba Oil - 110ml", "price": 79 },
  { "name": "Colorbar Nail Polish Remover Pack of 2 - 220ml", "price": 325 },
  { "name": "Bee Organik Natural Nail Polish Remover - 30ml", "price": 295 },
  { "name": "Kara Nail Polish Remover Wipes - Pack of 2", "price": 180 },
  { "name": "Colorbar Ultimate Nail Enamel Remover - Orange Chocolate - 80ml", "price": 182 },
  { "name": "Jaquline USA Dip N' Clean Nail Polish Remover - 80ml", "price": 8669 },
  { "name": "Bellavita Dip 'n' Twist Nail Polish Remover - 60ml", "price": 14304 },
  { "name": "Chelsy Nail Polish Remover Wipes - Pack of 2", "price": 149 },
  { "name": "MYADDICTION Nail Polish Corrector Pen with 3 Tips", "price": 369 },
  { "name": "VERYMISS Nail Polish Remover Wipes - 24 Wipes", "price": 70 },
  { "name": "Cutikles Nail Polish Remover Gel - 30ml", "price": 298 },
  { "name": "French Girl Nail & Cuticle Oil - 0.3 fl oz", "price": 2252 },
  { "name": "Amado Natural Moisturizing Cuticle Oil", "price": 886 },
  { "name": "La Conchita Naturals Botanical Cuticle Oil", "price": 1049 },
  { "name": "Cuticle Oil with Dried Flowers & Hearts", "price": 830 },
  { "name": "Indrani Cosmetics Cuticle Cream - 175g", "price": 360 },
  { "name": "Onsen Healing Mineral Nail Restoration Kit", "price": 4545 },
  { "name": "Moha Nail Care Cream - 100g", "price": 159 },
  { "name": "WOW Skin Science Coconut Hand & Nail Cream - 50ml", "price": 293 },
  { "name": "Fixderma Hand Cream with Cocoa Butter - 30g", "price": 205 },
  { "name": "Vaadi Herbals Nail & Cuticle Oil with Jojoba Oil - 10ml", "price": 80 },
  { "name": "Bella Vita Nail Strong Oil - 12ml", "price": 149 },
  { "name": "SHILLS Rose Dried Flowers Cuticle Oil - 15ml", "price": 284 },
  { "name": "Bluesky Cuticle Oil Pen - 1.6g", "price": 299 },
  { "name": "Cuccio Revitalizing Cuticle Oil - Milk & Honey - 2.5 Oz", "price": 996 },
  { "name": "Hibiscus Monkey Nailed It Cuticle Oil - 10ml", "price": 492 },
  { "name": "Bolt Bee Cuticle Oil Pen - Pack of 5", "price": 299 },
  { "name": "Cuccio Cuticle Oil - Pomegranate & Fig - 15ml", "price": 699 },
  { "name": "ZAUKY Cuticle Oil Pen - Multicolor", "price": 99 },
  { "name": "THR3E STROKES Lavender Cuticle Oil - 15ml", "price": 199 },
  { "name": "CUTIKLES Cuticle Oil Roll-On - 10ml", "price": 198 },
  { "name": "NAILWIND Cuticle Oil Pen - Fruity Oil - 15ml", "price": 85 },
  { "name": "Vaadi Herbals Cuticle Oil Pack of 3 - 10ml each", "price": 237 },
  { "name": "Cuccio Aloe Vera Cuticle Oil - 15ml", "price": 664 },
  { "name": "DeBelle Ultra-Hydrating Cuticle Oil - 15ml", "price": 499 },
  { "name": "Beetles Nail Strengthener & Growth - 0.5 fl oz", "price": 646 },
  { "name": "VARNAIL Nail Strengthener Reinforce Gel", "price": 4488 },
  { "name": "Gelike EC Nail Growth Treatment - 15ml", "price": 1547 },
  { "name": "AmenBeauty Steel Nails Nail Strengthener", "price": 2807 },
  { "name": "Excuse Me Nail Hardener EXTRA Strength - 0.5 Oz", "price": 1368 },
  { "name": "Plum 3-in-1 Strengthener Base & Top Coat - 11ml", "price": 191 },
  { "name": "DeBelle Nail Hardener with Argan Oil - 15ml", "price": 390 },
  { "name": "Sally Hansen Advanced Hard as Nails - 0.45 Oz", "price": 899 },
  { "name": "Miss Claire Nail Hardener - 10ml", "price": 160 },
  { "name": "NAILWIND Nail Hardener - 15ml", "price": 95 },
  { "name": "Color Fx Nail Fix Anti Nail-Biting Polish - 6ml", "price": 299 },
  { "name": "Sally Hansen Diamond Strength Instant Hardener - 13.3ml", "price": 1275 },
  { "name": "BLUESKY Nail Booster with Keratin - 10ml", "price": 585 },
  { "name": "Cuccio Forte Nail Strengthener - 15ml", "price": 759 },
  { "name": "Matra 3-in-1 Nail Strengthener with Filers - 15ml", "price": 199 },
  { "name": "Isdin Si-Nails Daily Nail Strengthener - 2.5ml", "price": 2475 },


  { "name": "SUGAR POP Dip & Twist Nail Lacquer Remover - 60ml", "price": 150 },
  { "name": "Swiss Beauty Instant Dip & Twist Nail Remover - 80ml", "price": 134 },
  { "name": "Faces Nail Enamel Remover - 30ml", "price": 70 },
  { "name": "Insight Nail Polish Remover Wipes - Strawberry - 30 Wipes", "price": 49 },
  { "name": "Colorbar Nail Polish Remover Pack of 2 - 220ml", "price": 325 },
  { "name": "Kara Nail Polish Remover Wipes - Rose & Lemon - Pack of 2", "price": 180 },
  { "name": "OBN Nail Polish Remover Pads - Pack of 6", "price": 175 },
  { "name": "Tulips Nail Paint Remover Pads - Blueberry - Pack of 3", "price": 130 },
  { "name": "Juice Nail Paint Remover Liquid - 105ml", "price": 158 },
  { "name": "OSHEA Herbals Nail Paint Remover Liquid - 30ml", "price": 166 },
  { "name": "Majestique Nail Polish Remover & Toe Separator Set", "price": 186 },
  { "name": "Mirah Belle Acetone-Free Nail Paint Remover - 50ml", "price": 106 },
  { "name": "DeBelle Green Tea Gush Nail Paint Remover Pads - 25ml", "price": 145 },
  { "name": "DeBelle Lime Lush Nail Paint Remover Pads - 25ml", "price": 163 },
  { "name": "RTB OBN Nail Paint Remover Pads - Pack of 5", "price": 156 },
  { "name": "Bee Organik Organic Nail Polish Remover - 30ml", "price": 295 },
  { "name": "Calitate24 Nail Polish Remover Pads - Pack of 3", "price": 129 },
  { "name": "Kressa Nail Polish Remover Wipes – Pack of 2", "price": 169 },
  { "name": "AVEU Nail Paint Remover Pads - 120g", "price": 114 },
  { "name": "VEGA Cotton Ball Nail Paint Remover - Pack of 50", "price": 72 },
  { "name": "Enliven Nail Polish Remover - 250ml", "price": 275 },
  { "name": "SHILLS Rose Dried Flowers Cuticle Oil - 15ml", "price": 284 },
  { "name": "Bolt Bee Cuticle Oil Pen - Pack of 5", "price": 299 },
  { "name": "Cuccio Cuticle Oil - Pomegranate & Fig - 15ml", "price": 699 },
  { "name": "ZAUKY Cuticle Oil Pen - Multicolor", "price": 99 },
  { "name": "THR3E STROKES Lavender Cuticle Oil - 15ml", "price": 199 },
  { "name": "CUTIKLES Cuticle Oil Roll-On - 10ml", "price": 198 },
  { "name": "NAILWIND Cuticle Oil Pen - Fruity Oil - 15ml", "price": 85 },
  { "name": "Vaadi Herbals Cuticle Oil Pack of 3 - 10ml each", "price": 237 },
  { "name": "Cuccio Aloe Vera Cuticle Oil - 15ml", "price": 664 },
  { "name": "DeBelle Ultra-Hydrating Cuticle Oil - 15ml", "price": 499 },
  { "name": "RUBYFACE Natural Cuticle Oil - 15ml", "price": 195 },
  { "name": "Huda Crush Cuticle Oil Pen - 3ml x 2", "price": 225 },
  { "name": "Brille Bee Cuticle Oil - Strawberry - 15ml", "price": 199 },
  { "name": "Pinpai Cuticle Oil Pens - Pack of 5", "price": 399 },
  { "name": "PuriFlame Nail Strong Growth Oil - 30ml", "price": 181 },
  { "name": "Beetles Nail Strengthener & Growth - 0.5 fl oz", "price": 646 },
  { "name": "VARNAIL Nail Strengthener Reinforce Gel", "price": 4488 },
  { "name": "Gelike EC Nail Growth Treatment - 15ml", "price": 1547 },
  { "name": "AmenBeauty Steel Nails Nail Strengthener", "price": 2807 },
  { "name": "Excuse Me Nail Hardener EXTRA Strength - 0.5 Oz", "price": 1368 },
  { "name": "Plum 3-in-1 Strengthener Base & Top Coat - 11ml", "price": 191 },
  { "name": "DeBelle Nail Hardener with Argan Oil - 15ml", "price": 390 },
  { "name": "Sally Hansen Advanced Hard as Nails - 0.45 Oz", "price": 899 },
  { "name": "Miss Claire Nail Hardener - 10ml", "price": 160 },
  { "name": "NAILWIND Nail Hardener - 15ml", "price": 95 },
  { "name": "Color Fx Nail Fix Anti Nail-Biting Polish - 6ml", "price": 299 },
  { "name": "Sally Hansen Diamond Strength Instant Hardener - 13.3ml", "price": 1275 },
  { "name": "BLUESKY Nail Booster with Keratin - 10ml", "price": 585 },
  { "name": "Cuccio Forte Nail Strengthener - 15ml", "price": 759 },
  { "name": "Matra 3-in-1 Nail Strengthener with Filers - 15ml", "price": 199 },
  { "name": "Isdin Si-Nails Daily Nail Strengthener - 2.5ml", "price": 2475 },
  { "name": "Gellen 4-in-1 Nail Repair Serum - 15ml", "price": 799 },
  { "name": "Sally Hansen Maximum Growth Treatment - 13.3ml", "price": 999 },
  { "name": "Nail-Aid Keratin 3 Day Growth - 0.55 fl oz", "price": 1151 },
  { "name": "Nail-Aid Biotin Ultimate Strength - 0.55 fl oz", "price": 1151 },
  { "name": "Nail-Aid 5-in-1 Damaged Nails Multi-Repair", "price": 900 },
  { "name": "Nail serum for nail repair - 30ml", "price": 189 },
  { "name": "CUTIKLES Anti-Fungal Nail Serum - 30ml", "price": 198 },
  { "name": "Hoof Hard As Nail Strengthening Cream", "price": 1500 },
  { "name": "Color Fx Nail Fix Nail Moisturiser - 6ml", "price": 299 },
  { "name": "Sally Hansen Hard As Nails Regular - 13.3ml", "price": 1319 },
  { "name": "OPI Nail Strengthener Original Formula - 15ml", "price": 335 },
  { "name": "DeBelle Nail Care Combo - Primer & Hardener - 30ml", "price": 674 },
  { "name": "RENÉE Top Coat Glossy Finish - 10ml", "price": 119 },
  { "name": "LAKMÉ Unreal Gel Stylist Nail Care Oil - 12ml", "price": 399 },
  { "name": "O.P.I Nature Strong Top Coat - 15ml", "price": 700 },
  { "name": "Rx Amrolstar 5% Nail Lacquer - 2.5ml", "price": 450 },
  { "name": "Sally Hansen Hard As Wraps Strengthener - 20g", "price": 1319 },
  { "name": "OPI RapiDry 3-in-1 Top Coat - 15ml", "price": 522 },
  { "name": "DeBelle Nail Care Combo - Top & Base Coat - 30ml", "price": 835 },



  { "name": "Gellen 4-in-1 Nail Repair Serum - 15ml", "price": 799 },
  { "name": "Sally Hansen Maximum Growth Treatment - 13.3ml", "price": 999 },
  { "name": "Nail-Aid Keratin 3 Day Growth - 0.55 fl oz", "price": 1151 },
  { "name": "Nail-Aid Biotin Ultimate Strength - 0.55 fl oz", "price": 1151 },
  { "name": "Nail-Aid 5-in-1 Damaged Nails Multi-Repair", "price": 900 },
  { "name": "CUTIKLES Anti-Fungal Nail Serum - 30ml", "price": 198 },
  { "name": "Hoof Hard As Nail Strengthening Cream", "price": 1500 },
  { "name": "Color Fx Nail Fix Nail Moisturiser - 6ml", "price": 299 },
  { "name": "Sally Hansen Hard As Nails Regular - 13.3ml", "price": 1319 },
  { "name": "OPI Nail Strengthener Original Formula - 15ml", "price": 335 },
  { "name": "DeBelle Nail Care Combo - Primer & Hardener - 30ml", "price": 674 },
  { "name": "RENÉE Top Coat Glossy Finish - 10ml", "price": 119 },
  { "name": "LAKMÉ Unreal Gel Stylist Nail Care Oil - 12ml", "price": 399 },
  { "name": "O.P.I Nature Strong Top Coat - 15ml", "price": 700 },
  { "name": "Rx Amrolstar 5% Nail Lacquer - 2.5ml", "price": 450 },
  { "name": "Sally Hansen Hard As Wraps Strengthener - 20g", "price": 1319 },
  { "name": "OPI RapiDry 3-in-1 Top Coat - 15ml", "price": 522 },
  { "name": "DeBelle Nail Care Combo - Top & Base Coat - 30ml", "price": 835 },
  { "name": "Bejoy Instant Nail Paint Remover - 140g", "price": 229 },
  { "name": "FASHION COLOUR Dip & Twist Remover - 75ml", "price": 105 },
  { "name": "OBN Nail Polish Remover Pads - Pack of 6", "price": 175 },
  { "name": "Tulips Nail Paint Remover Pads - Pack of 3", "price": 130 },
  { "name": "Juice Nail Paint Remover Liquid - 105ml", "price": 158 },
  { "name": "OSHEA Herbals Nail Paint Remover Liquid - 30ml", "price": 166 },
  { "name": "Majestique Nail Polish Remover & Toe Separator Set", "price": 186 },
  { "name": "Mirah Belle Acetone-Free Nail Paint Remover - 50ml", "price": 106 },
  { "name": "DeBelle Green Tea Gush Remover Pads - 25ml", "price": 145 },
  { "name": "RTB OBN Nail Paint Remover Pads - Pack of 5", "price": 156 },
  { "name": "Calitate24 Nail Polish Remover Pads - Pack of 3", "price": 129 },
  { "name": "Kressa Nail Polish Remover Wipes – Pack of 2", "price": 169 },
  { "name": "AVEU Nail Paint Remover Pads - 120g", "price": 114 },
  { "name": "VEGA Cotton Ball Nail Paint Remover - Pack of 50", "price": 72 },
  { "name": "Enliven Nail Polish Remover - 250ml", "price": 275 },
  { "name": "BAD COMPANY Nail Polish Remover Wipes - Orange - 30 Pads", "price": 150 },
  { "name": "Swiss Beauty Easy-Peasy Remover Wipes - Strawberry - 32pcs", "price": 56 },
  { "name": "Swiss Beauty Easy-Peasy Remover Wipes - Aloe Vera - 32pcs", "price": 56 },
  { "name": "Faces Canada Nail Enamel Remover - 90ml", "price": 119 },
  { "name": "Jaquline USA Dip N' Clean Remover - 80ml - Rose", "price": 8669 },
  { "name": "BELLAVITA Dip 'n' Twist Remover - 60ml", "price": 14304 },
  { "name": "Dazller Nail Polish Remover Wipes - Pack of 3", "price": 196 },
  { "name": "Chelsy Nail Polish Remover Wipes - Pack of 2", "price": 149 },
  { "name": "MYADDICTION Nail Polish Corrector Pen with 3 Tips", "price": 369 },
  { "name": "VERYMISS Nail Polish Remover Wipes - 24 Wipes", "price": 70 },
  { "name": "Cutikles Nail Polish Remover Gel - 30ml", "price": 298 },
  { "name": "French Girl Nail & Cuticle Oil - 0.3 fl oz", "price": 2252 },
  { "name": "Amado Natural Moisturizing Cuticle Oil", "price": 886 },
  { "name": "La Conchita Naturals Botanical Cuticle Oil", "price": 1049 },
  { "name": "Cuticle Oil with Dried Flowers & Hearts", "price": 830 },
  { "name": "Natural Cuticle Oil with Jojoba & Almond", "price": 528 },
  { "name": "Onsen Healing Mineral Nail Restoration Kit", "price": 4545 },
  { "name": "Moha Nail Care Cream - 100g", "price": 159 },
  { "name": "WOW Skin Science Coconut Hand & Nail Cream - 50ml", "price": 293 },
  { "name": "Fixderma Hand Cream with Cocoa Butter - 30g", "price": 205 },
  { "name": "Vaadi Herbals Nail & Cuticle Oil with Jojoba Oil - 10ml", "price": 80 },
  { "name": "Bella Vita Nail Strong Oil - 12ml", "price": 149 },
  { "name": "SHILLS Rose Dried Flowers Cuticle Oil - 15ml", "price": 284 },
  { "name": "Bluesky Cuticle Oil Pen - 1.6g", "price": 299 },
  { "name": "Cuccio Revitalizing Cuticle Oil - Milk & Honey - 2.5 Oz", "price": 996 },
  { "name": "Hibiscus Monkey Nailed It Cuticle Oil - 10ml", "price": 492 },
  { "name": "Bolt Bee Cuticle Oil Pen - Pack of 5", "price": 299 },
  { "name": "Cuccio Cuticle Oil - Pomegranate & Fig - 15ml", "price": 699 },
  { "name": "ZAUKY Cuticle Oil Pen - Multicolor", "price": 99 },
  { "name": "THR3E STROKES Lavender Cuticle Oil - 15ml", "price": 199 },
  { "name": "CUTIKLES Cuticle Oil Roll-On - 10ml", "price": 198 },
  { "name": "NAILWIND Cuticle Oil Pen - Fruity Oil - 15ml", "price": 85 },
  { "name": "Vaadi Herbals Cuticle Oil Pack of 3 - 10ml each", "price": 237 },
  { "name": "Cuccio Aloe Vera Cuticle Oil - 15ml", "price": 664 },
  { "name": "DeBelle Ultra-Hydrating Cuticle Oil - 15ml", "price": 499 },


  { "name": "Sally Hansen Treatment 18K Gold Hardener - 0.33 fl oz", "price": 1514 },
  { "name": "Gellen Nail Strengthener 4-in-1 Serum - 15ml", "price": 799 },
  { "name": "OPI Nail Strengthener Original Formula - 15ml", "price": 335 },
  { "name": "Isdin Si-Nails Daily Nail Strengthener - 2.5ml", "price": 2475 },
  { "name": "Colorbar Ultimate Nail Enamel Remover - 80ml", "price": 129 },
  { "name": "Swiss Beauty Nail Polish Remover with Jojoba Oil - 110ml", "price": 79 },
  { "name": "RENÉE Nail Paint Remover - 30ml", "price": 79 },
  { "name": "Blue Heaven Gentle Nail Paint Remover - 125ml", "price": 91 },
  { "name": "Faces Canada InstaRemove Dip & Twist Remover - 80ml", "price": 125 },
  { "name": "Lakmé Nail Color Remover - 27ml", "price": 61 },
  { "name": "Colorbar On-the-Go Nail Lacquer Remover Wipes - 30pcs", "price": 129 },
  { "name": "Inatur Nail Paint Remover Wipes - 50 Wipes", "price": 108 },
  { "name": "BELLAVITA Dip 'n' Twist Nail Polish Remover - 60ml", "price": 14304 },
  { "name": "Jaquline USA Dip N' Clean Nail Polish Remover - 80ml", "price": 8669 },
  { "name": "Dazller Nail Polish Remover Wipes - Pack of 3", "price": 196 },
  { "name": "Chelsy Nail Polish Remover Wipes - Pack of 2", "price": 149 },
  { "name": "MYADDICTION Nail Polish Corrector Pen with 3 Tips", "price": 369 },
  { "name": "VERYMISS Nail Polish Remover Wipes - 24 Wipes", "price": 70 },
  { "name": "Cutikles Nail Polish Remover Gel - 30ml", "price": 298 },
  { "name": "French Girl Nail & Cuticle Oil - 0.3 fl oz", "price": 2252 },
  { "name": "Amado Natural Moisturizing Cuticle Oil", "price": 886 },
  { "name": "La Conchita Naturals Botanical Cuticle Oil", "price": 1049 },
  { "name": "Cuticle Oil with Dried Flowers & Hearts", "price": 830 },
  { "name": "Indrani Cosmetics Cuticle Cream - 175g", "price": 360 },
  { "name": "Moha Nail Care Cream - 100g", "price": 159 },
  { "name": "WOW Skin Science Coconut Hand & Nail Cream - 50ml", "price": 293 },
  { "name": "Fixderma Hand Cream with Cocoa Butter - 30g", "price": 205 },
  { "name": "Vaadi Herbals Nail & Cuticle Oil with Jojoba Oil - 10ml", "price": 80 },
  { "name": "Bella Vita Nail Strong Oil - 12ml", "price": 149 },
  { "name": "SHILLS Rose Dried Flowers Cuticle Oil - 15ml", "price": 284 },
  { "name": "Bluesky Cuticle Oil Pen - 1.6g", "price": 299 },
  { "name": "Cuccio Revitalizing Cuticle Oil - Milk & Honey - 2.5 Oz", "price": 996 },
  { "name": "Hibiscus Monkey Nailed It Cuticle Oil - 10ml", "price": 492 },
  { "name": "Bolt Bee Cuticle Oil Pen - Pack of 5", "price": 299 },
  { "name": "Cuccio Cuticle Oil - Pomegranate & Fig - 15ml", "price": 699 },
  { "name": "ZAUKY Cuticle Oil Pen - Multicolor", "price": 99 },
  { "name": "THR3E STROKES Lavender Cuticle Oil - 15ml", "price": 199 },
  { "name": "CUTIKLES Cuticle Oil Roll-On - 10ml", "price": 198 },
  { "name": "NAILWIND Cuticle Oil Pen - Fruity Oil - 15ml", "price": 85 },
  { "name": "Vaadi Herbals Cuticle Oil Pack of 3 - 10ml each", "price": 237 },
  { "name": "Cuccio Aloe Vera Cuticle Oil - 15ml", "price": 664 },
  { "name": "DeBelle Ultra-Hydrating Cuticle Oil - 15ml", "price": 499 },
  { "name": "Beetles Nail Strengthener & Growth - 0.5 fl oz", "price": 646 },
  { "name": "VARNAIL Nail Strengthener Reinforce Gel", "price": 4488 },
  { "name": "Gelike EC Nail Growth Treatment - 15ml", "price": 1547 },
  { "name": "AmenBeauty Steel Nails Nail Strengthener", "price": 2807 },
  { "name": "Excuse Me Nail Hardener EXTRA Strength - 0.5 Oz", "price": 1368 },
  { "name": "Plum 3-in-1 Strengthener Base & Top Coat - 11ml", "price": 191 },
  { "name": "DeBelle Nail Hardener with Argan Oil - 15ml", "price": 390 },
  { "name": "Sally Hansen Advanced Hard as Nails - 0.45 Oz", "price": 899 },
  { "name": "Miss Claire Nail Hardener - 10ml", "price": 160 },
  { "name": "NAILWIND Nail Hardener - 15ml", "price": 95 },
  { "name": "Color Fx Nail Fix Anti Nail-Biting Polish - 6ml", "price": 299 },
  { "name": "Sally Hansen Diamond Strength Instant Hardener - 13.3ml", "price": 1275 },
  { "name": "BLUESKY Nail Booster with Keratin - 10ml", "price": 585 },
  { "name": "Cuccio Forte Nail Strengthener - 15ml", "price": 759 },
  { "name": "Matra 3-in-1 Nail Strengthener with Filers - 15ml", "price": 199 },
  { "name": "Isdin Si-Nails Daily Nail Strengthener - 2.5ml", "price": 2475 },
  { "name": "Gellen Nail Strengthener 4-in-1 Serum - 15ml", "price": 799 },
  { "name": "Sally Hansen Maximum Growth Treatment - 13.3ml", "price": 999 },
  { "name": "Nail-Aid Keratin 3 Day Growth - 0.55 fl oz", "price": 1151 },
  { "name": "Nail-Aid Biotin Ultimate Strength - 0.55 fl oz", "price": 1151 },
  { "name": "Nail-Aid 5-in-1 Damaged Nails Multi-Repair", "price": 900 },
  { "name": "CUTIKLES Anti-Fungal Nail Serum - 30ml", "price": 198 },
  { "name": "Hoof Hard As Nail Strengthening Cream", "price": 1500 },
  { "name": "Color Fx Nail Fix Nail Moisturiser - 6ml", "price": 299 },
  { "name": "Sally Hansen Hard As Nails Regular - 13.3ml", "price": 1319 },
  { "name": "OPI Nail Strengthener Original Formula - 15ml", "price": 335 },
  { "name": "DeBelle Nail Care Combo - Primer & Hardener - 30ml", "price": 674 },

             
                  ],
                    "Sun & Tanning": [
    { "name": "Neutrogena Ultra Sheer Dry-Touch Sunblock SPF 50+ - 80g", "price": 546 },
  { "name": "Dot & Key Vitamin C + E Super Bright Sunscreen SPF 50 - 50g", "price": 396 },
  { "name": "WishCare 5% Niacinamide Fluid Sunscreen SPF 50 - 50g", "price": 384 },
  { "name": "Lakme Sun Expert SPF 50 Gel - 50g", "price": 218 },
  { "name": "Hyphen All I Need Sunscreen SPF 50 - 50ml", "price": 420 },
  { "name": "Beauty of Joseon Relief Sun SPF 50+ PA++++ - 50ml", "price": 1350 },
  { "name": "Minimalist Sunscreen SPF 50 PA++++ - 100g", "price": 699 },
  { "name": "Bellavita Water-Based Hydrating Sunscreen SPF 50 - 50ml", "price": 179 },
  { "name": "POND'S Sun Miracle SPF 55 PA+++ Light Sunscreen - 50g", "price": 189 },
  { "name": "Conscious Chemist Berry Bright Gel Sunscreen SPF 50 - 50g", "price": 299 },
  { "name": "Deconstruct Gel Sunscreen SPF 50 PA+++ - Pack of 2 x 50g", "price": 600 },
  { "name": "Dot & Key Blueberry Hydrate Barrier Repair Sunscreen SPF 50 - 50g", "price": 396 },
  { "name": "The Derma Co 1% Hyaluronic Sunscreen Aqua Gel SPF 50 - 125g", "price": 898 },
  { "name": "WishCare Sunscreen Body Lotion SPF 50 - 200ml", "price": 399 },
  { "name": "Lakme Sun Expert SPF 50 PA+++ Ultra Matte Lotion - 100ml", "price": 338 },
  { "name": "Dr. Sheth's Ceramide & Vitamin C Sunscreen SPF 50 - 125g", "price": 982 },
  { "name": "Dot & Key CICA Calming Mattifying Sunscreen SPF 50 - 50g", "price": 396 },
  { "name": "Brinton UvDoux Face & Body Sunscreen Gel SPF 50 - 100g", "price": 1191 },
  { "name": "Plum 2% Niacinamide & Rice Water Sunscreen SPF 50 - 15g", "price": 147 },
  { "name": "Aqualogica Radiance+ Dewy Sunscreen Gel SPF 50 - 50g", "price": 394 },
  { "name": "Nivea Sun Moisturizing After-Sun Lotion - 200ml", "price": 1181 },
  { "name": "Hawaiian Tropic Lime Coolada After Sun Lotion - Pack of 12 x 2oz", "price": 5679 },
  { "name": "NIVEA SUN After Sun Moisturising Soothing Lotion - 200ml", "price": 1920 },
  { "name": "Malibu After Sun Lotion Aloe Vera & Vitamin E - 3.4 fl oz", "price": 2338 },
  { "name": "Malibu Sun After Sun Soothing Moisturising Lotion - 100ml", "price": 875 },
  { "name": "Cosmo Designs Beaute After Sun Cool Down Body Lotion - 1000ml", "price": 725 },
  { "name": "Arganicare Summer After-Sun Body Lotion - 250ml", "price": 1842 },
  { "name": "Shiseido After-Sun Intensive Recovery Emulsion", "price": 3918 },
  { "name": "Evoluderm Monoï à la Folie After-Sun Body Balm - 250ml", "price": 680 },
  { "name": "Australian Gold After Sun Face Cream - 50ml", "price": 2162 },
  { "name": "Talika Bio Enzymes Cica Repair+ After Sun Mask - 20g", "price": 970 },
  { "name": "NUXE Sun Refreshing After-Sun Lotion - 400ml", "price": 1797 },
  { "name": "Hawaiian Tropic Hydrating After-Sun Oil - 150ml", "price": 1038 },
  { "name": "ByRokko Aloe Vera After Sun Gel Original - 200ml", "price": 1442 },
  { "name": "Sesderma Hidraloe Aloe Gel Face & Body - 500ml", "price": 979 },
  { "name": "Carroten After Sun Panthenol & Aloe Vera Cooling Gel - 200ml", "price": 1033 },
  { "name": "Lierac Sunissime Fresh After-Sun Gel - 200ml", "price": 1256 },
  { "name": "Coola Sunless Tan Firming Lotion - 177ml", "price": 6205 },
  { "name": "Ziaja Sun After-Sun Soothing Gel - 200ml", "price": 408 },
  { "name": "Biotherm Oligo-Thermal After-Sun Milk - 400ml", "price": 4276 },
  { "name": "Clarins After-Sun Refreshing Gel - 150ml", "price": 2491 },
  { "name": "Piz Buin After-Sun Moisturizing Lotion - 200ml", "price": 1488 },
  { "name": "Jergens Natural Glow Instant Sun Body Mousse - 6oz", "price": 4481 },
  { "name": "BeautybyEarth Ultra Dark Self Tanner Mousse", "price": 3543 },
  { "name": "Self Tanner Lotion Fair to Medium - 6oz", "price": 2818 },
  { "name": "FirstMelody 30X Clear Bronzer Self Tanner Mousse", "price": 2338 },
  { "name": "b.tan Darkest Self Tanner Mousse - 6.7oz", "price": 4238 },
  { "name": "L'Oreal Sublime Bronze Self-Tanning Mist - 4.6oz", "price": 2290 },
  { "name": "St. Moriz Instant Self Tanning Mousse - Medium - 200ml", "price": 2611 },
  { "name": "Bondi Sands Liquid Gold Self Tanning Foam - 7.04oz", "price": 3210 },
  { "name": "Tan-Luxe The Body Illuminating Self Tan Drops - 95ml", "price": 3124 },
  { "name": "Dripping Gold Luxury Tanning Mousse - 200ml", "price": 1886 },
  { "name": "Bare by Vogue Self Tan Foam - Medium - 200ml", "price": 2299 },
  { "name": "Clarins Self Tanning Milky Lotion - 125ml", "price": 3040 },
  { "name": "Bali Body Ultra Dark Self Tanning Mousse - 200ml", "price": 3147 },
  { "name": "Teaology Bronzing Tea Drops Self-Tanning Serum - 30ml", "price": 2884 },
  { "name": "Ziaja Cupuaçu Bronzing Body Lotion - 300ml", "price": 701 },
  { "name": "COCOSOLIS Solis Self-Tanning Face Serum - 50ml", "price": 4454 },
  { "name": "Biotherm Aqua-Gelée Autobronzante Face Serum - 50ml", "price": 3011 },
  { "name": "Nivea Q10 Firming + Bronze Body Lotion - 250ml", "price": 1171 },
  { "name": "Bali Body Gradual Tanning Butter - 220g", "price": 3567 },
  { "name": "Bondi Sands PURE Self-Tanning Sleep Mask - 100ml", "price": 4167 },
  { "name": "Isle of Paradise Self Tanning Oil Mist - 100ml", "price": 3848 },
  { "name": "Loving Tan Bronze Shimmer Luminous Cream - Ultra Dark", "price": 3950 },
  { "name": "Sun Laboratories Dark Sunsation Self Tanning Lotion - 4oz", "price": 2753 },
  { "name": "St. Tropez Self Tan Extra Dark Bronzing Mousse - 200ml", "price": 3609 },
  { "name": "Bondi Sands Aero Aerated Self Tanning Foam - 225ml", "price": 1504 },
  { "name": "MineTan Color Correcting Self Tanner Mousse", "price": 3097 },
  { "name": "Devoted Creations White 2 Black Bronzer Tanning Lotion - 8.5oz", "price": 2782 },




  { "name": "Mamaearth HydraGel Indian Sunscreen SPF 50 - 50g", "price": 399 },
  { "name": "Suntribe Zinc Sunscreen SPF50 Original White - 45g", "price": 1646 },
  { "name": "WishCare Sunscreen SPF50 Body & Face Combo - 200ml + 50g", "price": 779 },
  { "name": "Altruist Sunscreen SPF50 - 100ml", "price": 871 },
  { "name": "mCaffeine Daily Brightening Sunscreen SPF 50 - 100ml", "price": 1297 },
  { "name": "Aryanveda Herbals Sun Protective SPF-20 - 100ml", "price": 213 },
  { "name": "VLCC No More Sun Tan Sunscreen - 100ml", "price": 4029 },
  { "name": "Shahnaz Husain Nano Sun Block SPF 25 - 100ml", "price": 180 },
  { "name": "Lotus Herbals Collagenshield Sunblock SPF 90 - 100ml", "price": 595 },
  { "name": "Jovees Anjeer & Carrot Sunblock SPF 45 - 100ml", "price": 289 },
  { "name": "Jovees Sandalwood Natural Sun Cover SPF 30 - 100ml", "price": 175 },
  { "name": "Jovees Fairness Lotion Water Resistant SPF 25 - 100ml", "price": 349 },
  { "name": "Lotus Herbals Safe Sun Skin Lightening SPF 30 - 100ml", "price": 219 },
  { "name": "Sunflow Sun Screen Lotion SPF 30 - 100ml", "price": 275 },
  { "name": "Sunblock Matte Finish SPF 50 PA++++ - 50ml", "price": 130 },
  { "name": "Sun Protective Cream SPF 30 - 60ml", "price": 275 },
  { "name": "Dot & Key Strawberry Dew Tinted Sunscreen SPF 50 - 50ml", "price": 357 },
  { "name": "Sunshade Ultra Block Sunscreen Lotion SPF 30 - 50ml", "price": 190 },
  { "name": "Sunhalt Gold Hydrating Sunscreen SPF 50 PA+++ - 60ml", "price": 457 },
  { "name": "Dermistry Natural Mineral Sunscreen SPF 50 - 50ml", "price": 248 },
  { "name": "Cetaphil Sun Light High Protection SPF 30 - 100ml", "price": 1182 },
  { "name": "Keya Seth Aromatherapy Umbrella Sunscreen Powder SPF 50 - 50g", "price": 295 },
  { "name": "Sunprotek SPF 30 Lotion - 100ml", "price": 583 },
  { "name": "La Shield Expert Urban Protect Mineral Sunscreen SPF 50 - 50ml", "price": 279 },
  { "name": "Rivela Sunscreen SPF 50 Lotion - 50ml", "price": 629 },
  { "name": "Plix Jamun Matte Screen Invisible Sunscreen SPF 50 - 50ml", "price": 650 },
  { "name": "VLCC Radiance Pro SPF 30 Sun Screen Gel - 100ml", "price": 363 },
  { "name": "Bioderma Photoderm Fluide Max SPF 100 - 40ml", "price": 1364 },
  { "name": "Glaminor Matt Finish Sun Screen Gel SPF 50 - 50ml", "price": 685 },
  { "name": "Mamaearth Vitamin C Daily Glow Sunscreen SPF 50 - 50ml", "price": 290 },
  { "name": "Photon 360 Matt Sunscreen Gel SPF 50 PA+++ - 50ml", "price": 990 },
  { "name": "Suncros 50 Aqua Sunscreen SPF 50 - 60ml", "price": 501 },
  { "name": "Glaminor IR Shield Sunscreen Gel SPF 50 PA+++ - 50ml", "price": 317 },
  { "name": "Dermistry Ultra Lite Matte Finish Sunscreen SPF 50 - 50ml", "price": 248 },
  { "name": "Leeford Sunshade Ultra Block Sunscreen Lotion SPF 30 - 50ml", "price": 190 },
  { "name": "Oxyglow Herbals Sun Cover Cream SPF 30++ - 60ml", "price": 137 },
  { "name": "Sun Laboratories Dark Sunsation Self Tanning Lotion - 4oz", "price": 2753 },
  { "name": "St. Tropez Self Tan Extra Dark Bronzing Mousse - 200ml", "price": 3609 },
  { "name": "Bondi Sands Aero Aerated Self Tanning Foam - 225ml", "price": 1504 },
  { "name": "MineTan Color Correcting Self Tanner Mousse - 200ml", "price": 3097 },
  { "name": "Devoted Creations White 2 Black Bronzer Tanning Lotion - 8.5oz", "price": 2782 },
  { "name": "BeautybyEarth Self Tanner Tanning Mousse - Ultra Dark - 200ml", "price": 3543 },
  { "name": "Jergens Natural Glow Instant Sun Body Mousse - 6oz", "price": 4481 },
  { "name": "b.tan Darkest Self Tanner Mousse - 6.7oz", "price": 4238 },
  { "name": "FirstMelody 30X Clear Bronzer Self Tanner Mousse - 200ml", "price": 2338 },
  { "name": "Self Tanner Lotion Fair to Medium - 6oz", "price": 2818 },
  { "name": "Tan-Luxe The Body Illuminating Self Tan Drops - 95ml", "price": 3124 },
  { "name": "Dripping Gold Luxury Tanning Mousse - 200ml", "price": 1886 },
  { "name": "Bare by Vogue Self Tan Foam - Medium - 200ml", "price": 2299 },
  { "name": "Clarins Self Tanning Milky Lotion - 125ml", "price": 3040 },
  { "name": "Bali Body Ultra Dark Self Tanning Mousse - 200ml", "price": 3147 },
  { "name": "Teaology Bronzing Tea Drops Self-Tanning Serum - 30ml", "price": 2884 },
  { "name": "Ziaja Cupuaçu Bronzing Body Lotion - 300ml", "price": 701 },
  { "name": "COCOSOLIS Solis Self-Tanning Face Serum - 50ml", "price": 4454 },
  { "name": "Biotherm Aqua-Gelée Autobronzante Face Serum - 50ml", "price": 3011 },
  { "name": "Nivea Q10 Firming + Bronze Body Lotion - 250ml", "price": 1171 },
  { "name": "Bali Body Gradual Tanning Butter - 220g", "price": 3567 },
  { "name": "Bondi Sands PURE Self-Tanning Sleep Mask - 100ml", "price": 4167 },
  { "name": "Isle of Paradise Self Tanning Oil Mist - 100ml", "price": 3848 },
  { "name": "Loving Tan Bronze Shimmer Luminous Cream - Ultra Dark", "price": 3950 },
  { "name": "Bondi Sands Liquid Gold Self Tanning Foam - 7.04oz", "price": 3210 },
  { "name": "Sunless Tanning Daily Facial Cream - 50ml", "price": 3102 },
  { "name": "Body Drench Quick Tan Bronzing Spray - 177ml", "price": 2807 },
  { "name": "Tan Physics True Color Tanner - 8oz", "price": 5546 },
  { "name": "Bondi Sands Dark Self Tanning Foam Value Kit - 2x200ml", "price": 5019 },
  { "name": "COOLA Organic Sunless Self Tanner Dry Oil Mist - 100ml", "price": 5552 },
  { "name": "St. Tropez Self Tan Bronzing Mousse - 1.69oz", "price": 2357 },
  { "name": "Bondi Sands Aero Aerated Self Tanning Foam Liquid Gold - 225ml", "price": 1504 },



  { "name": "Re'equil Ultra Matte Dry Touch Sunscreen SPF 50 PA++++ - 50g", "price": 780 },
  { "name": "La Shield Fisico Matte Sunscreen Gel SPF 50 - 50g", "price": 630 },
  { "name": "Foxtale Cover Up Sunscreen SPF 50 PA++++ - 50ml", "price": 495 },
  { "name": "Earth Rhythm Ultra Defence Hybrid Sunscreen SPF 50 - 50ml", "price": 599 },
  { "name": "Fixderma Shadow SPF 50+ Gel - 75g", "price": 595 },
  { "name": "SebaMed Multiprotect Sunscreen SPF 50+ - 80ml", "price": 899 },
  { "name": "Aroma Magic Sunblock Lotion SPF 30 - 100ml", "price": 210 },
  { "name": "Biotique Bio Carrot Face & Body Sun Lotion SPF 40 - 120ml", "price": 274 },
  { "name": "Just Herbs Tinted Serum Sunscreen SPF 50+ PA+++ - 50ml", "price": 298 },
  { "name": "The Ayurveda Co. Sunscreen SPF 50 PA++++ - 50ml", "price": 399 },
  { "name": "SunScoop Invisible Sunscreen SPF 40 PA++++ - 45g", "price": 399 },
  { "name": "Re'equil Sheer Zinc Tinted Sunscreen SPF 50 PA+++ - 50g", "price": 595 },
  { "name": "Pilgrim Squalane Ultra Matte Sunscreen SPF 50 PA+++ - 50g", "price": 350 },
  { "name": "Dr. Sheth's Centella & Niacinamide Sunscreen SPF 50 - 50g", "price": 448 },
  { "name": "Earth Rhythm Matte Mineral Sunscreen SPF 50 - 50ml", "price": 599 },
  { "name": "SunScoop Glow Sunscreen SPF 60 PA++++ - 45g", "price": 449 },
  { "name": "Re'equil Oxybenzone & OMC Free Sunscreen SPF 50 PA+++ - 50g", "price": 460 },
  { "name": "Foxtale Dewy Sunscreen SPF 50 PA++++ - 50ml", "price": 495 },
  { "name": "Fixderma Shadow SPF 30+ Cream - 75g", "price": 495 },
  { "name": "SebaMed Sun Lotion SPF 30 - 150ml", "price": 899 },
  { "name": "Biotique Bio Sandalwood Sunscreen SPF 50+ - 120ml", "price": 210 },
  { "name": "Aroma Magic Aloe Vera Sunscreen Gel SPF 20 - 100ml", "price": 180 },
  { "name": "Just Herbs Herb Enriched Sunscreen Gel SPF 50 - 50ml", "price": 325 },
  { "name": "The Ayurveda Co. Matte Sunscreen SPF 50 - 50ml", "price": 399 },
  { "name": "SunScoop Fluid Sunscreen SPF 60 PA++++ - 45g", "price": 449 },
  { "name": "Bondi Sands Everyday SPF 50+ Sunscreen Lotion - 200ml", "price": 999 },
  { "name": "Clarins Sun Care Cream SPF 30 - 150ml", "price": 2490 },
  { "name": "Lancaster Sun Beauty Velvet Milk SPF 50 - 175ml", "price": 3599 },
  { "name": "Coola Classic Face Sunscreen SPF 50 - 50ml", "price": 6205 },
  { "name": "La Roche-Posay Anthelios XL SPF 50+ Fluid - 50ml", "price": 2250 },
  { "name": "Avène Very High Protection Cream SPF 50+ - 50ml", "price": 1799 },
  { "name": "NUXE Sun High Protection SPF 50 Lotion - 150ml", "price": 1797 },
  { "name": "Piz Buin Tan & Protect SPF 30 Lotion - 200ml", "price": 1488 },
  { "name": "Australian Gold Botanical Sunscreen SPF 50 - 89ml", "price": 2162 },
  { "name": "Sesderma Repaskin Dry Touch SPF 50 - 50ml", "price": 979 },
  { "name": "Ziaja Sun Protection Cream SPF 50+ - 50ml", "price": 408 },
  { "name": "Clarins After Sun Moisturizer Ultra-Hydrating - 200ml", "price": 2491 },
  { "name": "NUXE Sun Refreshing After-Sun Lotion - 400ml", "price": 1797 },
  { "name": "ByRokko Shine Brown After Sun Gel - 200ml", "price": 1442 },
  { "name": "Ziaja After Sun Tan Prolonger - 200ml", "price": 699 },
  { "name": "Sesderma Hidraloe Aloe Gel - 500ml", "price": 979 },
  { "name": "Carroten After Sun Cooling Gel - 200ml", "price": 1033 },
  { "name": "Lierac Sunissime After-Sun Sorbet - 50ml", "price": 1615 },
  { "name": "Avène After-Sun Restorative Lotion - 400ml", "price": 1018 },
  { "name": "Piz Buin After Sun Tan Intensifying Lotion - 200ml", "price": 1488 },
  { "name": "Australian Gold Forever After Moisturizer - 237ml", "price": 1433 },
  { "name": "Clarins After Sun Refreshing Gel - 150ml", "price": 2491 },
  { "name": "Coola Radical Recovery After Sun Lotion - 148ml", "price": 6205 },
  { "name": "Biotherm After Sun Oligo-Thermal Milk - 400ml", "price": 4276 },
  { "name": "Bondi Sands Aloe Vera After Sun Gel - 200ml", "price": 1504 },
  { "name": "St. Tropez Gradual Tan In Shower Lotion - 200ml", "price": 3609 },
  { "name": "Bondi Sands Self Tanning Foam Ultra Dark - 200ml", "price": 3147 },
  { "name": "Tanologist Express Self Tan Water - 200ml", "price": 2884 },
  { "name": "Bali Body Face Tan Water - 100ml", "price": 3146 },
  { "name": "Clarins Self Tanning Instant Gel - 125ml", "price": 3040 },
  { "name": "Dripping Gold Wonder Water Self Tan - 100ml", "price": 1886 },
  { "name": "Bare by Vogue Self Tan Lotion Dark - 200ml", "price": 2299 },
  { "name": "Teaology Bronzing Tea Drops Serum - 30ml", "price": 2884 },
  { "name": "Ziaja Cupuaçu Bronzing Lotion - 300ml", "price": 701 },
  { "name": "COCOSOLIS Self-Tanning Face Serum - 50ml", "price": 4454 },
  { "name": "Biotherm Aqua-Gelée Autobronzante Serum - 50ml", "price": 3011 },
  { "name": "Nivea Q10 Firming + Bronze Lotion - 250ml", "price": 1171 },
  { "name": "Bondi Sands PURE Sleep Mask - 100ml", "price": 4167 },
  { "name": "Isle of Paradise Tanning Oil Mist - 100ml", "price": 3848 },
  { "name": "Loving Tan Bronze Shimmer Cream Ultra Dark - 120ml", "price": 3950 },
  { "name": "Sun Laboratories Dark Sunsation Lotion - 4oz", "price": 2753 },
  { "name": "St. Tropez Extra Dark Bronzing Mousse - 200ml", "price": 3609 },
  { "name": "Bondi Sands Aero Liquid Gold Foam - 225ml", "price": 1504 },
  { "name": "MineTan Color Correcting Mousse - 200ml", "price": 3097 },
  { "name": "Devoted Creations White 2 Black Bronzer Lotion - 8.5oz", "price": 2782 },


  { "name": "Dr. Sheth's Sunscreen SPF 50 PA+++ with Ceramide & Vitamin C - 80g", "price": 699 },
  { "name": "Aqualogica Glow+ Dewy Sunscreen SPF 50 PA+++ - 50g", "price": 381 },
  { "name": "Dot & Key Watermelon Cooling Sunscreen SPF 50 PA++++ - 50g", "price": 396 },
  { "name": "The Derma Co 1% Hyaluronic Sunscreen Aqua Gel SPF 50 PA++++ - 125g", "price": 898 },
  { "name": "Plum 2% Niacinamide & Rice Water Sunscreen SPF 50 PA+++ - 15g", "price": 147 },
  { "name": "Bondi Sands Everyday SPF 50+ Sunscreen Lotion - 200ml", "price": 999 },
  { "name": "Clarins Sun Care Cream SPF 30 - 150ml", "price": 2490 },
  { "name": "Lancaster Sun Beauty Velvet Milk SPF 50 - 175ml", "price": 3599 },
  { "name": "Coola Classic Face Sunscreen SPF 50 - 50ml", "price": 6205 },
  { "name": "La Roche-Posay Anthelios XL SPF 50+ Fluid - 50ml", "price": 2250 },
  { "name": "Avène Very High Protection Cream SPF 50+ - 50ml", "price": 1799 },
  { "name": "NUXE Sun High Protection SPF 50 Lotion - 150ml", "price": 1797 },
  { "name": "Piz Buin Tan & Protect SPF 30 Lotion - 200ml", "price": 1488 },
  { "name": "Australian Gold Botanical Sunscreen SPF 50 - 89ml", "price": 2162 },
  { "name": "Sesderma Repaskin Dry Touch SPF 50 - 50ml", "price": 979 },
  { "name": "Ziaja Sun Protection Cream SPF 50+ - 50ml", "price": 408 },
  { "name": "Clarins After Sun Moisturizer Ultra-Hydrating - 200ml", "price": 2491 },
  { "name": "ByRokko Shine Brown After Sun Gel - 200ml", "price": 1442 },
  { "name": "Ziaja After Sun Tan Prolonger - 200ml", "price": 699 },
  { "name": "Avène After-Sun Restorative Lotion - 400ml", "price": 1018 },
  { "name": "Piz Buin After Sun Tan Intensifying Lotion - 200ml", "price": 1488 },
  { "name": "Australian Gold Forever After Moisturizer - 237ml", "price": 1433 },
  { "name": "Coola Radical Recovery After Sun Lotion - 148ml", "price": 6205 },
  { "name": "Biotherm After Sun Oligo-Thermal Milk - 400ml", "price": 4276 },
  { "name": "Bondi Sands Aloe Vera After Sun Gel - 200ml", "price": 1504 },
  { "name": "St. Tropez Gradual Tan In Shower Lotion - 200ml", "price": 3609 },
  { "name": "Tanologist Express Self Tan Water - 200ml", "price": 2884 },
  { "name": "Bali Body Face Tan Water - 100ml", "price": 3146 },
  { "name": "Clarins Self Tanning Instant Gel - 125ml", "price": 3040 },
  { "name": "Dripping Gold Wonder Water Self Tan - 100ml", "price": 1886 },
  { "name": "Bare by Vogue Self Tan Lotion Dark - 200ml", "price": 2299 },
  { "name": "Teaology Bronzing Tea Drops Serum - 30ml", "price": 2884 },
  { "name": "COCOSOLIS Self-Tanning Face Serum - 50ml", "price": 4454 },
  { "name": "Biotherm Aqua-Gelée Autobronzante Serum - 50ml", "price": 3011 },
  { "name": "Bondi Sands PURE Sleep Mask - 100ml", "price": 4167 },
  { "name": "Isle of Paradise Tanning Oil Mist - 100ml", "price": 3848 },
  { "name": "Loving Tan Bronze Shimmer Cream Ultra Dark - 120ml", "price": 3950 },
  { "name": "Sun Laboratories Dark Sunsation Lotion - 4oz", "price": 2753 },
  { "name": "St. Tropez Extra Dark Bronzing Mousse - 200ml", "price": 3609 },
  { "name": "Bondi Sands Aero Liquid Gold Foam - 225ml", "price": 1504 },
  { "name": "MineTan Color Correcting Mousse - 200ml", "price": 3097 },
  { "name": "Devoted Creations White 2 Black Bronzer Lotion - 8.5oz", "price": 2782 },
  { "name": "BeautybyEarth Self Tanner Tanning Mousse Ultra Dark - 200ml", "price": 3543 },
  { "name": "Jergens Natural Glow Instant Sun Mousse - 6oz", "price": 4481 },
  { "name": "b.tan Darkest Self Tanner Mousse - 6.7oz", "price": 4238 },
  { "name": "FirstMelody 30X Clear Bronzer Self Tanner Mousse - 200ml", "price": 2338 },
  { "name": "Self Tanner Lotion Fair to Medium - 6oz", "price": 2818 },
  { "name": "Tan-Luxe The Body Illuminating Self Tan Drops - 95ml", "price": 3124 },
  { "name": "Dripping Gold Luxury Tanning Mousse - 200ml", "price": 1886 },
  { "name": "Bare by Vogue Self Tan Foam Medium - 200ml", "price": 2299 },
  { "name": "Bali Body Ultra Dark Self Tanning Mousse - 200ml", "price": 3147 },
  { "name": "Ziaja Cupuaçu Bronzing Body Lotion - 300ml", "price": 701 },
  { "name": "Nivea Q10 Firming + Bronze Body Lotion - 250ml", "price": 1171 },
  { "name": "Bali Body Gradual Tanning Butter - 220g", "price": 3567 },
  { "name": "Bondi Sands Liquid Gold Self Tanning Foam - 7.04oz", "price": 3210 },
  { "name": "Tanologist Gradual Self Tan Lotion - 200ml", "price": 2884 },
  { "name": "Bondi Sands Self Tanning Foam Light/Medium - 200ml", "price": 2144 },
  { "name": "St. Moriz Instant Self Tanning Mousse Medium - 200ml", "price": 2611 },
  { "name": "Clarins Self Tanning Milky Lotion - 125ml", "price": 3040 },
  { "name": "Bondi Sands Aero Aerated Foam Ultra Dark - 225ml", "price": 1504 },
  { "name": "MineTan Coconut Water Self Tan Foam - 200ml", "price": 3097 },
  { "name": "Devoted Creations Famous Faces Facial Tanner - 120ml", "price": 1825 },
  { "name": "BeautybyEarth Self Tanner Spray Medium/Dark - 6oz", "price": 5497 },
  { "name": "St. Tropez Self Tan Bronzing Mousse - 1.69oz", "price": 2357 },
  { "name": "Tan Physics True Color Tanner - 8oz", "price": 5546 },
  { "name": "Bondi Sands Dark Foam Value Kit - 2x200ml", "price": 5019 },
  { "name": "COOLA Organic Dry Oil Mist Self Tanner - 100ml", "price": 5552 },
  { "name": "Body Drench Quick Tan Bronzing Spray - 177ml", "price": 2807 },
  { "name": "Sunless Tanning Daily Facial Cream - 50ml", "price": 3102 },
  { "name": "Self Tanner & Application Kit Bundle", "price": 8982 },

             
                  ],
                    "Bath & Body": [
    { "name": "ENN Glow Ghee Hydrating Body Lotion with Aloe & Saffron - 240ml", "price": 360 },
  { "name": "COROnation Herbal Cocoa & Shea Butter Moisturising Body Lotion - 300ml", "price": 399 },
  { "name": "Medimade Cocoa Butter Body Lotion - 300ml", "price": 399 },
  { "name": "Desi Crew Shea & Cocoa Butter Moisturizing Body Lotion - 300ml", "price": 600 },
  { "name": "The Body Shop Shea Body Butter - 200ml", "price": 1270 },
  { "name": "The Body Shop British Rose Body Butter - 200ml", "price": 1270 },
  { "name": "The Body Shop Almond Milk & Honey Body Butter - 200ml", "price": 1270 },
  { "name": "The Body Shop Wild Argan Oil Body Butter - 200ml", "price": 1270 },
  { "name": "The Body Shop Olive Nourishing Body Butter - 200ml", "price": 1270 },
  { "name": "The Body Shop Satsuma Body Butter - 200ml", "price": 1195 },
  { "name": "The Body Shop Strawberry Body Butter - 200ml", "price": 1270 },
  { "name": "The Body Shop Lotus Body Lotion - 200ml", "price": 695 },
  { "name": "Vaseline Cocoa Glow Whipped Body Butter - 180g", "price": 324 },
  { "name": "Himalaya Rich Cocoa Butter Body Cream - 200ml", "price": 172 },
  { "name": "mCaffeine Naked & Rich Choco Body Butter - 250g", "price": 520 },
  { "name": "Bath & Body Works Gingham Glow Body Butter - 226g", "price": 1000 },
  { "name": "Bath & Body Works Brightest Bloom Body Butter - 226g", "price": 1000 },
  { "name": "Bath & Body Works Perfect In Pink Body Butter - 226g", "price": 1000 },
  { "name": "Bath & Body Works Strawberry Pound Cake Body Butter - 226g", "price": 920 },
  { "name": "Bath & Body Works Gingham Glow Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Brightest Bloom Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Perfect In Pink Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Gingham Glow Body Cream - 226g", "price": 920 },
  { "name": "Bath & Body Works Brightest Bloom Body Cream - 226g", "price": 920 },
  { "name": "Bath & Body Works Perfect In Pink Body Cream - 226g", "price": 920 },
  { "name": "Bath & Body Works Gingham Glow Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Brightest Bloom Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Perfect In Pink Body Scrub - 226g", "price": 1080 },
  { "name": "Bath & Body Works Gingham Fresh Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Strawberry Pound Cake Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Gingham Body Scrub - 226g", "price": 1000 },
  { "name": "Kimirica Frangipani Bath Salt - 300g", "price": 643 },
  { "name": "Soulflower Lavender Bath Salt - 500g", "price": 405 },
  { "name": "Soulflower Ocean Blue Bath Salt - 500g", "price": 405 },
  { "name": "Soulflower Himalayan Pink Rock Bath Salt - 500g", "price": 405 },
  { "name": "Khadi Organique Rose Geranium Bath Salt - 200g", "price": 180 },
  { "name": "Khadi Organique Lavender & Ylang Ylang Bath Salt - 200g", "price": 190 },
  { "name": "Aromahpure Mandarin Orchid Patchouli Bath Salt - 250g", "price": 315 },
  { "name": "Aromahpure Bergamot Marine Lavender Bath Salt - 250g", "price": 315 },
  { "name": "Aromahpure Frangipani Bath Salt - 250g", "price": 305 },
  { "name": "Aromahpure Fasli Rose Bath Salt - 250g", "price": 315 },
  { "name": "Aromahpure Citrus Grove Bath Salt - 250g", "price": 315 },
  { "name": "Aromahpure Joyful Lavender Bath Salt - 250g", "price": 305 },
  { "name": "Lavenflo Lavender Epsom Bath Salt - 500g", "price": 319 },
  { "name": "Rayflo Lavender Bath Salt - 500g", "price": 319 },
  { "name": "Morwen Lime & Lemongrass Bath Salt - 500g", "price": 350 },
  { "name": "LA NATURAL Eucalyptus & Peppermint Bath Salt - 200g", "price": 415 },
  { "name": "Home Boutique Rose Essential Oil Bath Salt - 200g", "price": 330 },
  { "name": "VÉDELA Lemon Bath Salt - 250g", "price": 244 },
  { "name": "VÉDELA Lavender Bath Salt - 300g", "price": 299 },
  { "name": "OLDGOA Lavender Bath Salt - 300g", "price": 199 },
  { "name": "AU Aroma Urbano Camphor Bath Salt - 900g", "price": 197 },
  { "name": "Urbanorganics Lavender Bath Salt - 900g", "price": 297 },
  { "name": "Khadi Organique Rose Bath Salt - 200g", "price": 199 },
  { "name": "Myra Veda Dead Sea Mineral Bath Salt - 100g", "price": 205 },
  { "name": "Shrida Naturals Lavender Bath Salt - 908g", "price": 349 },
  { "name": "YOGAFY Himalayan Pink Bath Salt - 350g", "price": 177 },
  { "name": "Unitedlys Lavender Bath Salt - 380g", "price": 189 },
  { "name": "Mesmara Epsom Bath Salt - 800g", "price": 220 },
  { "name": "Organix Mantra Epsom Bath Salt - 1kg", "price": 265 },
  { "name": "TrustBasket Epsom Salt Crystals - 1kg", "price": 198 },
  { "name": "Happy Squirrel Epsom Salt - 900g", "price": 275 },
  { "name": "Fast-Acting Epsom Salt - 1kg", "price": 280 },
  { "name": "Nankings Tea Tree Foot Soak Bath Salt - 1kg", "price": 489 },
  { "name": "Soul Magik Negativity Removal Spiritual Bath Salt - 200g", "price": 849 },
  { "name": "Tattvalogy Epsom Salt with Eucalyptus Oil - 900g", "price": 244 },
  { "name": "Leanbeing Pure Epsom Salt Crystals - 500g", "price": 202 },
  { "name": "Bliss of Earth Epsom Salt - 1kg", "price": 201 },
  { "name": "Mesmara Epsom Salt - 800g", "price": 220 },
  { "name": "Khadi Omorose Epsom Bath Salt - 500g", "price": 251 },
  { "name": "Shrida Naturals Himalayan Pink Salt Bath Blend - 908g", "price": 349 },


  { "name": "mCaffeine Coffee Body Lotion with Cocoa Butter - 250ml", "price": 399 },
  { "name": "Mamaearth Vitamin C Body Lotion - 400ml", "price": 349 },
  { "name": "NIVEA Aloe Hydration Body Lotion - 400ml", "price": 299 },
  { "name": "Vaseline Intensive Care Deep Restore Lotion - 400ml", "price": 285 },
  { "name": "Parachute Advansed Body Lotion Deep Nourish - 400ml", "price": 289 },
  { "name": "Joy Honey & Almonds Nourishing Body Lotion - 500ml", "price": 195 },
  { "name": "Biotique Morning Nectar Flawless Skin Moisturizer - 190ml", "price": 151 },
  { "name": "POND'S Triple Vitamin Moisturizing Lotion - 300ml", "price": 513 },
  { "name": "Dove Supple Bounce Body Lotion - 400ml", "price": 399 },
  { "name": "BOROPLUS Doodh Kesar Body Lotion - 400ml", "price": 215 },
  { "name": "Fixderma Moisturizing Lotion for Dry Skin - 100ml", "price": 302 },
  { "name": "Yardley London English Lavender Body Lotion - 350ml", "price": 170 },
  { "name": "Everyuth Naturals Body Lotion with Sun Care Berries SPF 15 - 300ml", "price": 170 },
  { "name": "Moha Herbal Body Lotion - 200ml", "price": 199 },
  { "name": "The Love Co. Soothing Melon Body Lotion - 200ml", "price": 349 },
  { "name": "Khadi Natural Rose & Honey Body Lotion - 210ml", "price": 199 },
  { "name": "WOW Skin Science Coconut Milk Body Lotion - 300ml", "price": 293 },
  { "name": "Plum BodyLovin' Vanilla Vibes Body Lotion - 250ml", "price": 399 },
  { "name": "Mamaearth Rice Water Hydrating Body Lotion - 400ml", "price": 245 },
  { "name": "Biotique Ubtan & Collagen Brightening Body Lotion - 210ml", "price": 189 },
  { "name": "Bath & Body Works Japanese Cherry Blossom Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Into The Night Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works A Thousand Wishes Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Warm Vanilla Sugar Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Gingham Fresh Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Strawberry Pound Cake Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Perfect In Pink Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Brightest Bloom Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Gingham Glow Body Lotion - 236ml", "price": 880 },
  { "name": "Bath & Body Works Gingham Body Lotion - 236ml", "price": 880 },
  { "name": "Kimirica Love Story Bath Oil - 100ml", "price": 699 },
  { "name": "Soulflower Rose Bath Oil - 100ml", "price": 450 },
  { "name": "Khadi Organique Lavender Bath Oil - 100ml", "price": 300 },
  { "name": "Aromahpure Mandarin Orchid Patchouli Bath Oil - 100ml", "price": 315 },
  { "name": "Aromahpure Bergamot Marine Lavender Bath Oil - 100ml", "price": 315 },
  { "name": "Aromahpure Frangipani Bath Oil - 100ml", "price": 305 },
  { "name": "Aromahpure Fasli Rose Bath Oil - 100ml", "price": 315 },
  { "name": "Aromahpure Citrus Grove Bath Oil - 100ml", "price": 315 },
  { "name": "Aromahpure Joyful Lavender Bath Oil - 100ml", "price": 305 },
  { "name": "Lavenflo Lavender Bath Oil - 100ml", "price": 319 },
  { "name": "Rayflo Lavender Bath Oil - 100ml", "price": 319 },
  { "name": "Morwen Lime & Lemongrass Bath Oil - 100ml", "price": 350 },
  { "name": "LA NATURAL Eucalyptus & Peppermint Bath Oil - 100ml", "price": 415 },
  { "name": "Home Boutique Rose Essential Oil Bath Oil - 100ml", "price": 330 },
  { "name": "VÉDELA Lemon Bath Oil - 100ml", "price": 244 },
  { "name": "VÉDELA Lavender Bath Oil - 100ml", "price": 299 },
  { "name": "OLDGOA Lavender Bath Oil - 100ml", "price": 199 },
  { "name": "AU Aroma Urbano Camphor Bath Oil - 100ml", "price": 197 },
  { "name": "Urbanorganics Lavender Bath Oil - 100ml", "price": 297 },
  { "name": "Khadi Organique Rose Bath Oil - 100ml", "price": 199 },
  { "name": "Myra Veda Dead Sea Mineral Bath Oil - 100ml", "price": 205 },
  { "name": "Shrida Naturals Lavender Bath Oil - 100ml", "price": 349 },
  { "name": "YOGAFY Himalayan Pink Bath Oil - 100ml", "price": 177 },
  { "name": "Unitedlys Lavender Bath Oil - 100ml", "price": 189 },
  { "name": "Mesmara Epsom Bath Oil - 100ml", "price": 220 },
  { "name": "Organix Mantra Epsom Bath Oil - 100ml", "price": 265 },
  { "name": "TrustBasket Epsom Bath Oil - 100ml", "price": 198 },
  { "name": "Happy Squirrel Epsom Bath Oil - 100ml", "price": 275 },
  { "name": "Fast-Acting Epsom Bath Oil - 100ml", "price": 280 },
  { "name": "Nankings Tea Tree Foot Soak Bath Oil - 100ml", "price": 489 },
  { "name": "Soul Magik Negativity Removal Spiritual Bath Oil - 100ml", "price": 849 },
  { "name": "Tattvalogy Epsom Bath Oil with Eucalyptus Oil - 100ml", "price": 244 },
  { "name": "Leanbeing Pure Epsom Bath Oil - 100ml", "price": 202 },
  { "name": "Bliss of Earth Epsom Bath Oil - 100ml", "price": 201 },
  { "name": "Khadi Omorose Epsom Bath Oil - 100ml", "price": 251 },
  { "name": "Shrida Naturals Himalayan Pink Salt Bath Oil Blend - 100ml", "price": 349 },


  { "name": "The Love Co. Rose & Shea Body Lotion - 250ml", "price": 349 },
  { "name": "Khadi Natural Herbal Sandalwood Body Lotion - 210ml", "price": 199 },
  { "name": "WOW Skin Science Aloe Vera Body Lotion - 300ml", "price": 293 },
  { "name": "Plum BodyLovin' Hawaiian Rumba Body Lotion - 250ml", "price": 399 },
  { "name": "Mamaearth Ubtan Body Lotion - 400ml", "price": 349 },
  { "name": "Biotique Bio Winter Cherry Rejuvenating Body Lotion - 210ml", "price": 189 },
  { "name": "NIVEA Cocoa Nourish Body Lotion - 400ml", "price": 299 },
  { "name": "Vaseline Healthy Bright Daily Brightening Body Lotion - 400ml", "price": 285 },
  { "name": "Parachute Advansed Soft Touch Body Lotion - 400ml", "price": 289 },
  { "name": "Joy Skin Fruits Moisturizing Body Lotion - 500ml", "price": 195 },
  { "name": "POND'S Triple Vitamin Body Lotion - 300ml", "price": 513 },
  { "name": "Dove Glowing Ritual Body Lotion - 400ml", "price": 399 },
  { "name": "BOROPLUS Aloe Neem Body Lotion - 400ml", "price": 215 },
  { "name": "Fixderma Moisturizing Lotion for Sensitive Skin - 100ml", "price": 302 },
  { "name": "Yardley London Rose Body Lotion - 350ml", "price": 170 },
  { "name": "Everyuth Naturals Sun Care Berry Body Lotion SPF 15 - 300ml", "price": 170 },
  { "name": "Moha Herbal Aloe Vera Body Lotion - 200ml", "price": 199 },
  { "name": "The Love Co. Mango Butter Body Lotion - 250ml", "price": 349 },
  { "name": "Khadi Natural Almond & Honey Body Lotion - 210ml", "price": 199 },
  { "name": "Plum BodyLovin' Drivin' Me Cherry Body Lotion - 250ml", "price": 399 },
  { "name": "Mamaearth Cocoa Butter Body Lotion - 400ml", "price": 349 },
  { "name": "Biotique Bio Apricot Refreshing Body Lotion - 210ml", "price": 189 },
  { "name": "NIVEA Whitening Even Tone Body Lotion SPF 15 - 400ml", "price": 299 },
  { "name": "Vaseline Intensive Care Aloe Soothe Body Lotion - 400ml", "price": 285 },
  { "name": "Parachute Advansed Coconut Milk Body Lotion - 400ml", "price": 289 },
  { "name": "Joy Pure Aloe Vera Body Lotion - 500ml", "price": 195 },
  { "name": "POND'S Moisturizing Body Lotion with Vitamin B3 - 300ml", "price": 513 },
  { "name": "Dove Nourishing Secrets Body Lotion - 400ml", "price": 399 },
  { "name": "BOROPLUS Doodh Kesar Body Lotion - 400ml", "price": 215 },
  { "name": "Fixderma Moisturizing Lotion for Oily Skin - 100ml", "price": 302 },
  { "name": "Yardley London Jasmine Body Lotion - 350ml", "price": 170 },
  { "name": "Everyuth Naturals Aloe Vera Body Lotion SPF 15 - 300ml", "price": 170 },
  { "name": "Moha Herbal Almond Body Lotion - 200ml", "price": 199 },
  { "name": "The Love Co. Lavender Body Lotion - 250ml", "price": 349 },
  { "name": "Khadi Natural Jasmine & Mogra Body Lotion - 210ml", "price": 199 },
  { "name": "Plum BodyLovin' Orchid-You-Not Body Lotion - 250ml", "price": 399 },
  { "name": "Mamaearth Rose Body Lotion - 400ml", "price": 349 },
  { "name": "Biotique Bio Morning Nectar Body Lotion - 210ml", "price": 189 },
  { "name": "NIVEA Oil in Lotion Cocoa Nourish - 400ml", "price": 299 },
  { "name": "Vaseline Intensive Care Cocoa Glow Body Lotion - 400ml", "price": 285 },
  { "name": "Parachute Advansed Aloe Vera Body Lotion - 400ml", "price": 289 },
  { "name": "Joy Skin Fruits Brightening Body Lotion - 500ml", "price": 195 },
  { "name": "POND'S Vitamin E Body Lotion - 300ml", "price": 513 },
  { "name": "Dove Light Hydration Body Lotion - 400ml", "price": 399 },
  { "name": "BOROPLUS Herbal Body Lotion - 400ml", "price": 215 },
  { "name": "Fixderma Moisturizing Lotion for Combination Skin - 100ml", "price": 302 },
  { "name": "Yardley London Lily of the Valley Body Lotion - 350ml", "price": 170 },
  { "name": "Everyuth Naturals Brightening Body Lotion SPF 15 - 300ml", "price": 170 },
  { "name": "Moha Herbal Rose Body Lotion - 200ml", "price": 199 },
  { "name": "The Love Co. Coconut Body Lotion - 250ml", "price": 349 },
  { "name": "Khadi Natural Neem & Tulsi Body Lotion - 210ml", "price": 199 },
  { "name": "Plum BodyLovin' Trippin' Mimosas Body Lotion - 250ml", "price": 399 },
  { "name": "Mamaearth Tea Tree Body Lotion - 400ml", "price": 349 },
  { "name": "Biotique Bio Honey Body Lotion - 210ml", "price": 189 },
  { "name": "NIVEA Smooth Milk Body Lotion - 400ml", "price": 299 },
  { "name": "Vaseline Intensive Care Advanced Repair Body Lotion - 400ml", "price": 285 },
  { "name": "Parachute Advansed Olive & Almond Body Lotion - 400ml", "price": 289 },
  { "name": "Joy Skin Fruits Hydrating Body Lotion - 500ml", "price": 195 },
  { "name": "POND'S Vitamin C Body Lotion - 300ml", "price": 513 },
  { "name": "Dove Deep Moisture Body Lotion - 400ml", "price": 399 },
  { "name": "BOROPLUS Ultra Moisturizing Body Lotion - 400ml", "price": 215 },
  { "name": "Fixderma Moisturizing Lotion for Normal Skin - 100ml", "price": 302 },
  { "name": "Yardley London Freesia Body Lotion - 350ml", "price": 170 },
  { "name": "Everyuth Naturals Hydrating Body Lotion SPF 15 - 300ml", "price": 170 },
  { "name": "Moha Herbal Jasmine Body Lotion - 200ml", "price": 199 },
  { "name": "The Love Co. Aloe Vera Body Lotion - 250ml", "price": 349 },
  { "name": "Khadi Natural Lemon Body Lotion - 210ml", "price": 199 },
  { "name": "Plum BodyLovin' Smokin' Vanilla Body Lotion - 250ml", "price": 399 },
  { "name": "Mamaearth Honey Malai Body Lotion - 400ml", "price": 349 },
  { "name": "Biotique Bio Papaya Body Lotion - 210ml", "price": 189 },


  { "name": "The Body Shop Almond Milk Body Butter - 200ml", "price": 1270 },
  { "name": "Bath & Body Works Warm Vanilla Sugar Body Butter - 226g", "price": 1000 },
  { "name": "Vaseline Intensive Care Cocoa Glow Body Butter - 180g", "price": 324 },
  { "name": "NIVEA Nourishing Body Milk - 400ml", "price": 299 },
  { "name": "Mamaearth Honey Malai Body Butter - 200ml", "price": 399 },
  { "name": "Plum BodyLovin' Vanilla Vibes Body Butter - 200g", "price": 499 },
  { "name": "mCaffeine Blueberry Swirl Deep Moisturizing Body Butter - 200g", "price": 345 },
  { "name": "Khadi Natural Herbal Almond Body Butter - 200g", "price": 199 },
  { "name": "Biotique Bio Cocoa Butter Body Cream - 175ml", "price": 189 },
  { "name": "Joy Skin Fruits Cocoa Butter Body Cream - 500ml", "price": 195 },
  { "name": "Fixderma Moisturizing Body Butter - 100ml", "price": 302 },
  { "name": "Moha Herbal Body Butter - 200ml", "price": 199 },
  { "name": "The Love Co. Mango Body Butter - 250ml", "price": 349 },
  { "name": "Kimirica Love Story Body Butter - 200ml", "price": 699 },
  { "name": "Soulflower Rose Body Butter - 200ml", "price": 450 },
  { "name": "Aromahpure Mandarin Patchouli Body Butter - 250ml", "price": 315 },
  { "name": "Rayflo Lavender Body Butter - 250ml", "price": 319 },
  { "name": "Morwen Lime & Lemongrass Body Butter - 250ml", "price": 350 },
  { "name": "LA NATURAL Eucalyptus & Peppermint Body Butter - 200ml", "price": 415 },
  { "name": "Home Boutique Rose Essential Oil Body Butter - 200ml", "price": 330 },
  { "name": "VÉDELA Lemon Body Butter - 250ml", "price": 244 },
  { "name": "OLDGOA Lavender Body Butter - 300g", "price": 199 },
  { "name": "AU Aroma Urbano Camphor Body Butter - 900g", "price": 197 },
  { "name": "Urbanorganics Lavender Body Butter - 900g", "price": 297 },
  { "name": "Myra Veda Dead Sea Mineral Body Butter - 100g", "price": 205 },
  { "name": "Shrida Naturals Himalayan Pink Salt Body Butter - 908g", "price": 349 },
  { "name": "YOGAFY Himalayan Pink Body Butter - 350g", "price": 177 },
  { "name": "Unitedlys Lavender Body Butter - 380g", "price": 189 },
  { "name": "Mesmara Epsom Body Butter - 800g", "price": 220 },
  { "name": "Organix Mantra Epsom Body Butter - 1kg", "price": 265 },
  { "name": "TrustBasket Epsom Body Butter - 1kg", "price": 198 },
  { "name": "Happy Squirrel Epsom Body Butter - 900g", "price": 275 },
  { "name": "Fast-Acting Epsom Body Butter - 1kg", "price": 280 },
  { "name": "Nankings Tea Tree Foot Soak Body Butter - 1kg", "price": 489 },
  { "name": "Soul Magik Negativity Removal Spiritual Body Butter - 200g", "price": 849 },
  { "name": "Tattvalogy Epsom Body Butter with Eucalyptus Oil - 900g", "price": 244 },
  { "name": "Leanbeing Pure Epsom Body Butter - 500g", "price": 202 },
  { "name": "Bliss of Earth Epsom Body Butter - 1kg", "price": 201 },
  { "name": "Khadi Omorose Epsom Body Butter - 500g", "price": 251 },
  { "name": "Bath & Body Works Japanese Cherry Blossom Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Into The Night Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works A Thousand Wishes Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Warm Vanilla Sugar Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Gingham Fresh Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Strawberry Pound Cake Body Scrub - 226g", "price": 1000 },
  { "name": "Bath & Body Works Perfect In Pink Body Scrub - 226g", "price": 1080 },
  { "name": "Kimirica Frangipani Body Scrub - 300g", "price": 643 },
  { "name": "Soulflower Lavender Body Scrub - 500g", "price": 405 },
  { "name": "Khadi Organique Rose Geranium Body Scrub - 200g", "price": 180 },
  { "name": "Aromahpure Mandarin Patchouli Body Scrub - 250g", "price": 315 },
  { "name": "Rayflo Lavender Body Scrub - 500g", "price": 319 },
  { "name": "Morwen Lime & Lemongrass Body Scrub - 500g", "price": 350 },
  { "name": "LA NATURAL Eucalyptus & Peppermint Body Scrub - 200g", "price": 415 },
  { "name": "Home Boutique Rose Essential Oil Body Scrub - 200g", "price": 330 },
  { "name": "VÉDELA Lemon Body Scrub - 250g", "price": 244 },
  { "name": "OLDGOA Lavender Body Scrub - 300g", "price": 199 },
  { "name": "AU Aroma Urbano Camphor Body Scrub - 900g", "price": 197 },
  { "name": "Urbanorganics Lavender Body Scrub - 900g", "price": 297 },
  { "name": "Myra Veda Dead Sea Mineral Body Scrub - 100g", "price": 205 },
  { "name": "Shrida Naturals Himalayan Pink Salt Body Scrub - 908g", "price": 349 },
  { "name": "YOGAFY Himalayan Pink Body Scrub - 350g", "price": 177 },
  { "name": "Unitedlys Lavender Body Scrub - 380g", "price": 189 },
  { "name": "Mesmara Epsom Body Scrub - 800g", "price": 220 },
  { "name": "Organix Mantra Epsom Body Scrub - 1kg", "price": 265 },
  { "name": "TrustBasket Epsom Body Scrub - 1kg", "price": 198 },
  { "name": "Happy Squirrel Epsom Body Scrub - 900g", "price": 275 },
  { "name": "Fast-Acting Epsom Body Scrub - 1kg", "price": 280 },
  { "name": "Nankings Tea Tree Foot Soak Body Scrub - 1kg", "price": 489 },
  { "name": "Soul Magik Negativity Removal Spiritual Body Scrub - 200g", "price": 849 },

             
                  ],
                  "Others": [
  { "name": "Other products", "price": 220 },
  { "name": "Other item", "price": 120 },
             
                  ],

   
  });

  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  


  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shareMethod, setShareMethod] = useState('');
  const [pdfFormat, setPdfFormat] = useState('default');


  const handleSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
  
    const allItems = Object.entries(categories).flatMap(([category, items]) =>
      items.map(item => ({ ...item, category }))
    );
  
    const filtered = allItems.filter(item =>
      item.name.toLowerCase().includes(text.toLowerCase())
    );
  
    setSuggestions(filtered);
  };

  const handleSelectSuggestion = (item) => {
    const newItem = {
      name: item.name,
      price: item.price,
      quantity: 1,
      subtotal: item.price * 1,
    };
    setCart([...cart, newItem]);
    setSearchText('');
    setSuggestions([]);
  };

  const handleNewBill = () => {
    setShopName('');
    setGstNumber('');
    setPhoneNumber('');
    setSelectedCategory('');
    setSelectedItem('');
    setQuantity(1);
    setCart([]);
    setGstRate(0);
    setSearchText('');
    setSuggestions([]);
    setPdfFormat('default');
  };
  

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedItem('');
    setQuantity(1);
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    setQuantity(1);
  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleAddItem = () => {
    const categoryItems = categories[selectedCategory];
    const item = categoryItems.find(i => i.name === selectedItem);
    if (item) {
      const newItem = {
        name: item.name,
        price: item.price,
        quantity: quantity,
        subtotal: item.price * quantity
      };
      setCart([...cart, newItem]);
      setSelectedItem('');
      setQuantity(1);
    }
  };

  const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handlePriceChange = (index, event) => {
    const newCart = [...cart];
    newCart[index].price = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleQuantityEdit = (index, event) => {
    const newCart = [...cart];
    newCart[index].quantity = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1); // Remove one item at the given index
    setCart(newCart);
  };
  
  const calculateTotal = () => {
    const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
    const gst = subtotal * (gstRate / 100);
    const total = subtotal + gst;
    return { subtotal, gst, total };
  };

  const generatePdfInvoice = () => {
    const total = calculateTotal();
    const currentDate = new Date().toLocaleDateString();
    const doc = new jsPDF();

    switch (pdfFormat) {
        case 'default':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'table':
            doc.autoTable({
                head: [[' Name', 'GST No', 'Phone Number', 'Date']],
                body: [[shopName, gstNumber, phoneNumber, currentDate]],
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'blueBlack':
            doc.setTextColor(0, 0, 255);
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.setTextColor(0, 0, 0);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'professionalGrid':
            doc.setFontSize(18);
            doc.text(shopName, 10, 10);
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 10, 20);
            doc.text(`Date: ${currentDate}`, 10, 30);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                theme: 'grid',
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                theme: 'grid',
            });
            break;

        case 'compactSummary':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

            
                case 'classicTable':
                    doc.setFontSize(20);
                    doc.text(shopName, 105, 15, null, null, 'center');
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
                    doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
                    doc.setFontSize(16);
                    doc.text('Invoice', 105, 30, null, null, 'center');
                    doc.autoTable({
                        startY: 40,
                        head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                        body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                    });
                    break;
        
                case 'boxedLayout':
                    doc.setFontSize(20);
                    doc.text(shopName, 10, 10);
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 10, 20);
                    doc.text(`Date: ${currentDate}`, 10, 30);
                    doc.autoTable({
                        startY: 40,
                        head: [['Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item) => [item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.5 },
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                        styles: { fillColor: [0, 180, 0], textColor: [0, 0, 0] },
                    });
            break;   
            
            

        case 'modernMinimalist':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity(Kg/ltr/each', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            break;

        case 'elegantLines':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            break;

        case 'detailedSections':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Section', 'Details']],
                body: [
                    ['Shop Details', `${shopName}, GST No: ${gstNumber}, Date: ${currentDate}`],
                    ['Items', cart.map((item) => `Name: ${item.name}, Quantity: ${item.quantity}, Subtotal: ${item.subtotal.toFixed(2)}`).join('; ')],
                    ['Totals', `Subtotal: ${total.subtotal.toFixed(2)}, GST: ${total.gst.toFixed(2)}, Total: ${total.total.toFixed(2)}`],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.5 },
            });
            break;

        

        default:
            break;
    }

    // Save the PDF to Blob
    const pdfBlob = doc.output('blob');

    // Share to WhatsApp
    const shareToWhatsApp = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(whatsappUrl, '_blank');
    };

    // Share to Email
    const shareToEmail = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const mailtoUrl = `mailto:?subject=Your Invoice&body=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(mailtoUrl, '_blank');
    };

    // Share the PDF as needed
    if (shareMethod === 'whatsapp') {
        shareToWhatsApp();
    } else if (shareMethod === 'mail') {
        shareToEmail();
    }

    // Save the PDF
    //doc.save('invoice.pdf');
    doc.save(`${shopName +'-invoice' || 'invoice'}.pdf`);

};


  const handleShare = (method) => {
    setShareMethod(method); // Set the sharing method
    const shareText = `Shop Name: ${shopName}\nGST No: ${gstNumber}\nPhone Number: ${phoneNumber}`;

    if (method === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(shareText)}`);
    } else if (method === 'mail') {
      window.open(`mailto:?subject=MarketApp%20Details&body=${encodeURIComponent(shareText)}`);
    }

    setShowModal(false); // Close modal after sharing
  };

  const handleGenerateAndShare = () => {
    generatePdfInvoice();
    setShowModal(true); // Show modal after generating PDF
  };

  const handleFormatChange = (e) => {
    setPdfFormat(e.target.value); // Set the PDF format
};

const formatOptions = [
    { value: 'default', label: 'Default' },
    { value: 'table', label: 'Table Format' },
    { value: 'blueBlack', label: 'Blue and Black' },
    { value: 'professionalGrid', label: 'Professional Grid' },
    { value: 'compactSummary', label: 'Compact Summary' },
    { value: 'classicTable', label: 'Classic Table' },
    { value: 'boxedLayout', label: 'Boxed Layout' },
    { value: 'modernMinimalist', label: 'Modern Minimalist' },
    { value: 'elegantLines', label: 'Elegant Lines' },
    { value: 'detailedSections', label: 'Detailed Sections' },
    
];


return (
    <div className="MarketApp">
       <img src="./Images/jalm.png" alt="Just A Little Market" width="100" height="100" />
      <h1><u> Beauty & Personal Care</u></h1>

<div style={{ marginTop: '20px', textAlign: 'left', paddingLeft: '10px' }}>
  <button
    onClick={handleNewBill}
    style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '12px 20px',
      fontSize: '18px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 123, 255, 0.3)',
      transition: 'background-color 0.3s ease, transform 0.2s ease'
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#0056b3';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#007bff';
      e.target.style.transform = 'scale(1)';
    }}
  >
    🧾 New Bill
  </button>
</div>
<br/>
 
  
      {/* Shop Info */}
  
    <div className="container">
  {/* Responsive Input Section */}
  <div className="input-section">
    <div className="form-group">
      <label>Beauty Care Name:</label>
      <input type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} />
    </div>

    <div className="form-group">
      <label>GST No:</label>
      <input type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Phone Number:</label>
      <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Search Items:</label>
      <input
        type="text"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Type to search..."
      />
      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((item, idx) => (
            <li key={idx} onClick={() => handleSelectSuggestion(item)}>
              {item.name} — ₹{item.price} <span className="category">({item.category})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {/* Category Selection */}
  <div className="form-group">
    <label>Select Category:</label>
    <select onChange={handleCategoryChange} value={selectedCategory}>
      <option value="" disabled>Select a category</option>
      {Object.keys(categories).map((cat, i) => (
        <option key={i} value={cat}>{cat}</option>
      ))}
    </select>
  </div>

  {selectedCategory && (
    <>
      <div className="form-group">
        <label>Select Item:</label>
        <select onChange={handleItemChange} value={selectedItem}>
          <option value="" disabled>Select an item</option>
          {categories[selectedCategory].map((item, i) => (
            <option key={i} value={item.name}>{item.name}</option>
          ))}
        </select>
      </div>

      {selectedItem && (
        <>
          <div className="form-group">
            <label>Quantity:</label>
            <input type="number" value={quantity} onChange={handleQuantityChange} min="1" />
          </div>
          <div className="form-group">
            <button onClick={handleAddItem}>Add Item</button>
          </div>
        </>
      )}
    </>
  )}

  {/* Cart Table */}
  <div className="cart-section">
    <h2>Cart</h2>
    {cart.length === 0 ? (
      <p>No items added.</p>
    ) : (
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handlePriceChange(index, e)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityEdit(index, e)}
                    min="1"
                  />
                </td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{calculateTotal().subtotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">
                GST Rate:
                <select onChange={handleGstRateChange} value={gstRate}>
                  <option value="0">0%</option>
                  <option value="5">5%</option>
                  <option value="6">6%</option>
                  <option value="9">9%</option>
                  <option value="18">18%</option>
                </select>
              </td>
              <td>{calculateTotal().gst.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">Total</td>
              <td>{calculateTotal().total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )}
  </div>

  {/* PDF Section */}
{cart.length > 0 && (
 
  <div className="pdf-section" style={{
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f1f3f5',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <label style={{
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    }}>
      🧾 Select Invoice Format:
    </label>

    <select
      onChange={handleFormatChange}
      value={pdfFormat}
      style={{
        padding: '10px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {formatOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    <button
      onClick={handleGenerateAndShare}
      style={{
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '14px',
        fontSize: '17px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
        transition: 'transform 0.2s ease, background-color 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = '#007bff';
        e.target.style.transform = 'scale(1)';
      }}
    >
      📄 Generate PDF Invoice
    </button>
  </div>
)}


<br /><br />

 

</div>

 </div>   
  ); // ✅ this closes the return statement
  
  
}

export default BeautyCare;
  


  

